import React, { useState,useEffect } from 'react';
import StockNavbar from '../../components/StockNavbar/StockNavbar';
import './Portfolio.css';
import { FaSearch } from 'react-icons/fa';
import axios from 'axios';

const Portfolio = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStock, setSelectedStock] = useState(null);
  const [quantity, setQuantity] = useState(0);
  const [price,setPrice] = useState(0.0);
  const [highprice,setHighPrice] = useState(0.0);
  const [lowprice,setLowPrice] = useState(0.0);
  const [open,setOpen] = useState(0.0);
  const [volume,setVolume] = useState(0);
  const [portfolio,setPortfolio] = useState([]);

  const stockNames = [
    { name: "20 Microns Limited", symbol: "20MICRONS" },
    {
      name: "21st Century Management Services Limited",
      symbol: "21STCENMGM",
    },
    { name: "3i Infotech Limited", symbol: "3IINFOLTD" },
    { name: "3M India Limited", symbol: "3MINDIA" },
    { name: "3P Land Holdings Limited", symbol: "3PLAND" },
    { name: "Fourth Dimension Solutions Limited", symbol: "4THDIM" },
    { name: "5Paisa Capital Limited", symbol: "5PAISA" },
    { name: "63 moons technologies limited", symbol: "63MOONS" },
    { name: "A2Z Infra Engineering Limited", symbol: "A2ZINFRA" },
    { name: "AAA Technologies Limited", symbol: "AAATECH" },
    { name: "Aakash Exploration Services Limited", symbol: "AAKASH" },
    { name: "Aarey Drugs & Pharmaceuticals Limited", symbol: "AAREYDRUGS" },
    { name: "Aaron Industries Limited", symbol: "AARON" },
    { name: "Aarti Drugs Limited", symbol: "AARTIDRUGS" },
    { name: "Aarti Industries Limited", symbol: "AARTIIND" },
    { name: "Aarti Surfactants Limited", symbol: "AARTISURF" },
    { name: "Aarvee Denims & Exports Limited", symbol: "AARVEEDEN" },
    { name: "Aarvi Encon Limited", symbol: "AARVI" },
    { name: "Aavas Financiers Limited", symbol: "AAVAS" },
    { name: "Aban Offshore Limited", symbol: "ABAN" },
    { name: "ABB India Limited", symbol: "ABB" },
    { name: "Abbott India Limited", symbol: "ABBOTINDIA" },
    { name: "Aditya Birla Capital Limited", symbol: "ABCAPITAL" },
    { name: "Aditya Birla Fashion and Retail Limited", symbol: "ABFRL" },
    { name: "ABM International Limited", symbol: "ABMINTLLTD" },
    { name: "Aditya Birla Sun Life AMC Limited", symbol: "ABSLAMC" },
    { name: "ACC Limited", symbol: "ACC" },
    { name: "Accelya Solutions India Limited", symbol: "ACCELYA" },
    { name: "Accuracy Shipping Limited", symbol: "ACCURACY" },
    { name: "Action Construction Equipment Limited", symbol: "ACE" },
    { name: "Ace Integrated Solutions Limited", symbol: "ACEINTEG" },
    { name: "Archean Chemical Industries Limited", symbol: "ACI" },
    { name: "Adani Enterprises Limited", symbol: "ADANIENT" },
    { name: "Adani Green Energy Limited", symbol: "ADANIGREEN" },
    {
      name: "Adani Ports and Special Economic Zone Limited",
      symbol: "ADANIPORTS",
    },
    { name: "Adani Power Limited", symbol: "ADANIPOWER" },
    { name: "Adani Transmission Limited", symbol: "ADANITRANS" },
    { name: "ADF Foods Limited", symbol: "ADFFOODS" },
    { name: "Archidply Decor Limited", symbol: "ADL" },
    { name: "Ador Welding Limited", symbol: "ADORWELD" },
    { name: "Adroit Infotech Limited", symbol: "ADROITINFO" },
    { name: "Allied Digital Services Limited", symbol: "ADSL" },
    { name: "Advani Hotels & Resorts (India) Limited", symbol: "ADVANIHOTR" },
    { name: "Advanced Enzyme Technologies Limited", symbol: "ADVENZYMES" },
    { name: "Aegis Logistics Limited", symbol: "AEGISCHEM" },
    { name: "Aether Industries Limited", symbol: "AETHER" },
    { name: "Affle (India) Limited", symbol: "AFFLE" },
    { name: "Agarwal Industrial Corporation Limited", symbol: "AGARIND" },
    { name: "AGI Greenpac Limited", symbol: "AGI" },
    { name: "Agri-Tech (India) Limited", symbol: "AGRITECH" },
    { name: "Agro Phos India Limited", symbol: "AGROPHOS" },
    { name: "AGS Transact Technologies Limited", symbol: "AGSTRA" },
    { name: "Abans Holdings Limited", symbol: "AHL" },
    { name: "Ahlada Engineers Limited", symbol: "AHLADA" },
    { name: "Asian Hotels (East) Limited", symbol: "AHLEAST" },
    { name: "Ahluwalia Contracts (India) Limited", symbol: "AHLUCONT" },
    { name: "AIA Engineering Limited", symbol: "AIAENG" },
    { name: "Airan Limited", symbol: "AIRAN" },
    { name: "Airo Lam limited", symbol: "AIROLAM" },
    { name: "Ajanta Pharma Limited", symbol: "AJANTPHARM" },
    { name: "Ajmera Realty & Infra India Limited", symbol: "AJMERA" },
    { name: "Ajooni Biotech Limited", symbol: "AJOONI" },
    { name: "AJR INFRA AND TOLLING LIMITED", symbol: "AJRINFRA" },
    { name: "Akash Infra-Projects Limited", symbol: "AKASH" },
    { name: "Akg Exim Limited", symbol: "AKG" },
    { name: "Akshar Spintex Limited", symbol: "AKSHAR" },
    { name: "AksharChem India Limited", symbol: "AKSHARCHEM" },
    { name: "Aksh Optifibre Limited", symbol: "AKSHOPTFBR" },
    { name: "Akzo Nobel India Limited", symbol: "AKZOINDIA" },
    { name: "Alankit Limited", symbol: "ALANKIT" },
    { name: "Albert David Limited", symbol: "ALBERTDAVD" },
    { name: "Alembic Limited", symbol: "ALEMBICLTD" },
    { name: "Alicon Castalloy Limited", symbol: "ALICON" },
    { name: "Alkali Metals Limited", symbol: "ALKALI" },
    { name: "Alkem Laboratories Limited", symbol: "ALKEM" },
    { name: "Alkyl Amines Chemicals Limited", symbol: "ALKYLAMINE" },
    { name: "Allcargo Logistics Limited", symbol: "ALLCARGO" },
    { name: "Allsec Technologies Limited", symbol: "ALLSEC" },
    { name: "Almondz Global Securities Limited", symbol: "ALMONDZ" },
    { name: "Alok Industries Limited", symbol: "ALOKINDS" },
    { name: "Alpa Laboratories Limited", symbol: "ALPA" },
    { name: "Alphageo (India) Limited", symbol: "ALPHAGEO" },
    { name: "Alps Industries Limited", symbol: "ALPSINDUS" },
    { name: "Amara Raja Batteries Limited", symbol: "AMARAJABAT" },
    { name: "Amber Enterprises India Limited", symbol: "AMBER" },
    {
      name: "Ambica Agarbathies & Aroma industries Limited",
      symbol: "AMBICAAGAR",
    },
    { name: "Ambika Cotton Mills Limited", symbol: "AMBIKCO" },
    { name: "Ambuja Cements Limited", symbol: "AMBUJACEM" },
    { name: "AMD Industries Limited", symbol: "AMDIND" },
    { name: "Ami Organics Limited", symbol: "AMIORG" },
    { name: "Amj Land Holdings Limited", symbol: "AMJLAND" },
    { name: "Amrutanjan Health Care Limited", symbol: "AMRUTANJAN" },
    { name: "Anand Rathi Wealth Limited", symbol: "ANANDRATHI" },
    { name: "Anant Raj Limited", symbol: "ANANTRAJ" },
    { name: "Andhra Cements Limited", symbol: "ANDHRACEMT" },
    { name: "ANDHRA PAPER LIMITED", symbol: "ANDHRAPAP" },
    { name: "The Andhra Sugars Limited", symbol: "ANDHRSUGAR" },
    { name: "Andrew Yule & Company Limited", symbol: "ANDREWYU" },
    { name: "Angel One Limited", symbol: "ANGELONE" },
    { name: "Anik Industries Limited", symbol: "ANIKINDS" },
    { name: "Ankit Metal & Power Limited", symbol: "ANKITMETAL" },
    { name: "Anmol India Limited", symbol: "ANMOL" },
    { name: "Antarctica Limited", symbol: "ANTGRAPHIC" },
    { name: "The Anup Engineering Limited", symbol: "ANUP" },
    { name: "Anupam Rasayan India Limited", symbol: "ANURAS" },
    { name: "Apar Industries Limited", symbol: "APARINDS" },
    { name: "Anjani Portland Cement Limited", symbol: "APCL" },
    { name: "Apcotex Industries Limited", symbol: "APCOTEXIND" },
    { name: "Apex Frozen Foods Limited", symbol: "APEX" },
    { name: "APL Apollo Tubes Limited", symbol: "APLAPOLLO" },
    { name: "Alembic Pharmaceuticals Limited", symbol: "APLLTD" },
    { name: "Apollo Micro Systems Limited", symbol: "APOLLO" },
    { name: "Apollo Hospitals Enterprise Limited", symbol: "APOLLOHOSP" },
    { name: "Apollo Pipes Limited", symbol: "APOLLOPIPE" },
    { name: "Apollo Tyres Limited", symbol: "APOLLOTYRE" },
    { name: "Apollo Sindoori Hotels Limited", symbol: "APOLSINHOT" },
    { name: "Aptech Limited", symbol: "APTECHT" },
    { name: "Aptus Value Housing Finance India Limited", symbol: "APTUS" },
    { name: "Archidply Industries Limited", symbol: "ARCHIDPLY" },
    { name: "Archies Limited", symbol: "ARCHIES" },
    { name: "Rajdarshan Industries Limited", symbol: "ARENTERP" },
    { name: "Aries Agro Limited", symbol: "ARIES" },
    { name: "Arihant Capital Markets Limited", symbol: "ARIHANTCAP" },
    { name: "Arihant Superstructures Limited", symbol: "ARIHANTSUP" },
    { name: "Arman Financial Services Limited", symbol: "ARMANFIN" },
    { name: "Aro Granite Industries Limited", symbol: "AROGRANITE" },
    { name: "Arrow Greentech Limited", symbol: "ARROWGREEN" },
    { name: "Arshiya Limited", symbol: "ARSHIYA" },
    { name: "ARSS Infrastructure Projects Limited", symbol: "ARSSINFRA" },
    { name: "Artemis Medicare Services Limited", symbol: "ARTEMISMED" },
    { name: "Art Nirman Limited", symbol: "ARTNIRMAN" },
    { name: "Arvee Laboratories (India) Limited", symbol: "ARVEE" },
    { name: "Arvind Limited", symbol: "ARVIND" },
    { name: "Arvind Fashions Limited", symbol: "ARVINDFASN" },
    { name: "Arvind SmartSpaces Limited", symbol: "ARVSMART" },
    { name: "Asahi India Glass Limited", symbol: "ASAHIINDIA" },
    { name: "Asahi Songwon Colors Limited", symbol: "ASAHISONG" },
    { name: "Automotive Stampings and Assemblies Limited", symbol: "ASAL" },
    { name: "Associated Alcohols & Breweries Ltd.", symbol: "ASALCBR" },
    { name: "Ashapura Minechem Limited", symbol: "ASHAPURMIN" },
    { name: "Ashiana Housing Limited", symbol: "ASHIANA" },
    { name: "Ashima Limited", symbol: "ASHIMASYN" },
    { name: "Ashoka Buildcon Limited", symbol: "ASHOKA" },
    { name: "Ashok Leyland Limited", symbol: "ASHOKLEY" },
    { name: "Asian Energy Services Limited", symbol: "ASIANENE" },
    { name: "Asian Hotels (North) Limited", symbol: "ASIANHOTNR" },
    { name: "Asian Paints Limited", symbol: "ASIANPAINT" },
    { name: "Asian Granito India Limited", symbol: "ASIANTILES" },
    { name: "Aspinwall and Company Limited", symbol: "ASPINWALL" },
    { name: "Astec LifeSciences Limited", symbol: "ASTEC" },
    { name: "Aster DM Healthcare Limited", symbol: "ASTERDM" },
    { name: "Astral Limited", symbol: "ASTRAL" },
    { name: "Astra Microwave Products Limited", symbol: "ASTRAMICRO" },
    { name: "AstraZeneca Pharma India Limited", symbol: "ASTRAZEN" },
    { name: "Astron Paper & Board Mill Limited", symbol: "ASTRON" },
    { name: "Agro Tech Foods Limited", symbol: "ATFL" },
    { name: "Adani Total Gas Limited", symbol: "ATGL" },
    { name: "Atlanta  Limited", symbol: "ATLANTA" },
    { name: "Atul Limited", symbol: "ATUL" },
    { name: "Atul Auto Limited", symbol: "ATULAUTO" },
    { name: "AU Small Finance Bank Limited", symbol: "AUBANK" },
    { name: "Aurionpro Solutions Limited", symbol: "AURIONPRO" },
    { name: "Aurobindo Pharma Limited", symbol: "AUROPHARMA" },
    { name: "Aurum PropTech Limited", symbol: "AURUM" },
    { name: "Ausom Enterprise Limited", symbol: "AUSOMENT" },
    { name: "Automotive Axles Limited", symbol: "AUTOAXLES" },
    { name: "Autoline Industries Limited", symbol: "AUTOIND" },
    { name: "Avadh Sugar & Energy Limited", symbol: "AVADHSUGAR" },
    { name: "Avanti Feeds Limited", symbol: "AVANTIFEED" },
    {
      name: "Avonmore Capital & Management Services Limited",
      symbol: "AVONMORE",
    },
    { name: "AVRO INDIA LIMITED", symbol: "AVROIND" },
    { name: "AVT Natural Products Limited", symbol: "AVTNPL" },
    { name: "Antony Waste Handling Cell Limited", symbol: "AWHCL" },
    { name: "Adani Wilmar Limited", symbol: "AWL" },
    { name: "Axis Bank Limited", symbol: "AXISBANK" },
    { name: "AXISCADES Technologies Limited", symbol: "AXISCADES" },
    { name: "Axita Cotton Limited", symbol: "AXITA" },
    { name: "AYM Syntex Limited", symbol: "AYMSYNTEX" },
    { name: "Bafna Pharmaceuticals Limited", symbol: "BAFNAPH" },
    { name: "B.A.G Films and Media Limited", symbol: "BAGFILMS" },
    { name: "Baid Finserv Limited", symbol: "BAIDFIN" },
    { name: "Bajaj Auto Limited", symbol: "BAJAJ-AUTO" },
    { name: "Bajaj Consumer Care Limited", symbol: "BAJAJCON" },
    { name: "Bajaj Electricals Limited", symbol: "BAJAJELEC" },
    { name: "Bajaj Finserv Limited", symbol: "BAJAJFINSV" },
    { name: "Bajaj Healthcare Limited", symbol: "BAJAJHCARE" },
    { name: "Bajaj Hindusthan Sugar Limited", symbol: "BAJAJHIND" },
    { name: "Bajaj Holdings & Investment Limited", symbol: "BAJAJHLDNG" },
    { name: "Bajaj Finance Limited", symbol: "BAJFINANCE" },
    { name: "Balaji Telefilms Limited", symbol: "BALAJITELE" },
    { name: "Balaji Amines Limited", symbol: "BALAMINES" },
    { name: "BALAXI PHARMACEUTICALS LIMITED", symbol: "BALAXI" },
    { name: "Balkrishna Paper Mills Limited", symbol: "BALKRISHNA" },
    { name: "Balkrishna Industries Limited", symbol: "BALKRISIND" },
    { name: "Ballarpur Industries Limited", symbol: "BALLARPUR" },
    { name: "Balmer Lawrie & Company Limited", symbol: "BALMLAWRIE" },
    { name: "Bal Pharma Limited", symbol: "BALPHARMA" },
    { name: "Balrampur Chini Mills Limited", symbol: "BALRAMCHIN" },
    { name: "Banaras Beads Limited", symbol: "BANARBEADS" },
    { name: "Bannari Amman Sugars Limited", symbol: "BANARISUG" },
    { name: "Banco Products (I) Limited", symbol: "BANCOINDIA" },
    { name: "Bandhan Bank Limited", symbol: "BANDHANBNK" },
    { name: "Bang Overseas Limited", symbol: "BANG" },
    { name: "Banka BioLoo Limited", symbol: "BANKA" },
    { name: "Bank of Baroda", symbol: "BANKBARODA" },
    { name: "Bank of India", symbol: "BANKINDIA" },
    { name: "Banswara Syntex Limited", symbol: "BANSWRAS" },
    { name: "Barbeque Nation Hospitality Limited", symbol: "BARBEQUE" },
    { name: "BASF India Limited", symbol: "BASF" },
    { name: "Bannari Amman Spinning Mills Limited", symbol: "BASML" },
    { name: "Bata India Limited", symbol: "BATAINDIA" },
    { name: "Bayer Cropscience Limited", symbol: "BAYERCROP" },
    { name: "Bharat Bijlee Limited", symbol: "BBL" },
    { name: "Black Box Limited", symbol: "BBOX" },
    { name: "Bombay Burmah Trading Corporation Limited", symbol: "BBTC" },
    { name: "B&B Triplewall Containers Limited", symbol: "BBTCL" },
    { name: "Brightcom Group Limited", symbol: "BCG" },
    { name: "Bcl Industries Limited", symbol: "BCLIND" },
    { name: "Brand Concepts Limited", symbol: "BCONCEPTS" },
    { name: "B.C. Power Controls Ltd", symbol: "BCP" },
    { name: "Bharat Dynamics Limited", symbol: "BDL" },
    { name: "Beardsell Limited", symbol: "BEARDSELL" },
    { name: "Mrs. Bectors Food Specialities Limited", symbol: "BECTORFOOD" },
    { name: "Bedmutha Industries Limited", symbol: "BEDMUTHA" },
    { name: "Bharat Electronics Limited", symbol: "BEL" },
    { name: "BEML Limited", symbol: "BEML" },
    { name: "Bhansali Engineering Polymers Limited", symbol: "BEPL" },
    { name: "Berger Paints (I) Limited", symbol: "BERGEPAINT" },
    { name: "Best Agrolife Limited", symbol: "BESTAGRO" },
    { name: "BF Investment Limited", symbol: "BFINVEST" },
    { name: "BF Utilities Limited", symbol: "BFUTILITIE" },
    { name: "BGR Energy Systems Limited", symbol: "BGRENERGY" },
    { name: "Bhagiradha Chemicals & Industries Limited", symbol: "BHAGCHEM" },
    { name: "Bhageria Industries Limited", symbol: "BHAGERIA" },
    { name: "Bhagyanagar India Limited", symbol: "BHAGYANGR" },
    { name: "Bhandari Hosiery Exports Limited", symbol: "BHANDARI" },
    { name: "Bharat Forge Limited", symbol: "BHARATFORG" },
    { name: "Bharat Gears Limited", symbol: "BHARATGEAR" },
    { name: "Bharat Rasayan Limited", symbol: "BHARATRAS" },
    { name: "Bharat Wire Ropes Limited", symbol: "BHARATWIRE" },
    { name: "Bharti Airtel Limited", symbol: "BHARTIARTL" },
    { name: "Bharat Heavy Electricals Limited", symbol: "BHEL" },
    { name: "Bigbloc Construction Limited", symbol: "BIGBLOC" },
    { name: "Bikaji Foods International Limited", symbol: "BIKAJI" },
    { name: "Bhartiya International Limited", symbol: "BIL" },
    { name: "Oswal Chemicals & Fertilizers Limited", symbol: "BINDALAGRO" },
    { name: "Biocon Limited", symbol: "BIOCON" },
    {
      name: "Biofil Chemicals & Pharmaceuticals Limited",
      symbol: "BIOFILCHEM",
    },
    { name: "Birla Cable Limited", symbol: "BIRLACABLE" },
    { name: "Birla Corporation Limited", symbol: "BIRLACORPN" },
    { name: "Aditya Birla Money Limited", symbol: "BIRLAMONEY" },
    { name: "Bkm Industries Limited", symbol: "BKMINDST" },
    { name: "BLB Limited", symbol: "BLBLIMITED" },
    { name: "Bliss GVS Pharma Limited", symbol: "BLISSGVS" },
    { name: "B. L. Kashyap and Sons Limited", symbol: "BLKASHYAP" },
    { name: "BLS International Services Limited", symbol: "BLS" },
    { name: "Blue Dart Express Limited", symbol: "BLUEDART" },
    { name: "Blue Star Limited", symbol: "BLUESTARCO" },
    { name: "Bodal Chemicals Limited", symbol: "BODALCHEM" },
    { name: "Bohra Industries Limited", symbol: "BOHRAIND" },
    { name: "Bombay Dyeing & Mfg Company Limited", symbol: "BOMDYEING" },
    { name: "Borosil Limited", symbol: "BOROLTD" },
    { name: "BOROSIL RENEWABLES LIMITED", symbol: "BORORENEW" },
    { name: "Bosch Limited", symbol: "BOSCHLTD" },
    { name: "Bharat Petroleum Corporation Limited", symbol: "BPCL" },
    { name: "BPL Limited", symbol: "BPL" },
    { name: "Brigade Enterprises Limited", symbol: "BRIGADE" },
    { name: "Britannia Industries Limited", symbol: "BRITANNIA" },
    { name: "Bharat Road Network Limited", symbol: "BRNL" },
    { name: "Brooks Laboratories Limited", symbol: "BROOKS" },
    { name: "BSE Limited", symbol: "BSE" },
    { name: "Bombay Super Hybrid Seeds Limited", symbol: "BSHSL" },
    { name: "BSL Limited", symbol: "BSL" },
    { name: "BIRLASOFT LIMITED", symbol: "BSOFT" },
    { name: "Burnpur Cement Limited", symbol: "BURNPUR" },
    { name: "Butterfly Gandhimathi Appliances Limited", symbol: "BUTTERFLY" },
    { name: "Barak Valley Cements Limited", symbol: "BVCL" },
    { name: "The Byke Hospitality Ltd", symbol: "BYKE" },
    { name: "California Software Company Limited", symbol: "CALSOFT" },
    { name: "Camlin Fine Sciences Limited", symbol: "CAMLINFINE" },
    { name: "Campus Activewear Limited", symbol: "CAMPUS" },
    { name: "Computer Age Management Services Limited", symbol: "CAMS" },
    { name: "Canara Bank", symbol: "CANBK" },
    { name: "Can Fin Homes Limited", symbol: "CANFINHOME" },
    { name: "Cantabil Retail India Limited", symbol: "CANTABIL" },
    { name: "Capacit'e Infraprojects Limited", symbol: "CAPACITE" },
    { name: "Caplin Point Laboratories Limited", symbol: "CAPLIPOINT" },
    { name: "Capital Trust Limited", symbol: "CAPTRUST" },
    { name: "Carborundum Universal Limited", symbol: "CARBORUNIV" },
    { name: "Career Point Limited", symbol: "CAREERP" },
    { name: "CARE Ratings Limited", symbol: "CARERATING" },
    { name: "Cartrade Tech Limited", symbol: "CARTRADE" },
    { name: "CARYSIL LIMITED", symbol: "CARYSIL" },
    { name: "Castrol India Limited", symbol: "CASTROLIND" },
    { name: "Consolidated Construction Consortium Limited", symbol: "CCCL" },
    { name: "Country Club Hospitality & Holidays Limited", symbol: "CCHHL" },
    { name: "CCL Products (India) Limited", symbol: "CCL" },
    { name: "Central Depository Services (India) Limited", symbol: "CDSL" },
    { name: "CEAT Limited", symbol: "CEATLTD" },
    { name: "Celebrity Fashions Limited", symbol: "CELEBRITY" },
    { name: "Century Enka Limited", symbol: "CENTENKA" },
    { name: "Century Extrusions Limited", symbol: "CENTEXT" },
    { name: "Central Bank of India", symbol: "CENTRALBK" },
    { name: "Centrum Capital Limited", symbol: "CENTRUM" },
    { name: "Centum Electronics Limited", symbol: "CENTUM" },
    { name: "Century Plyboards (India) Limited", symbol: "CENTURYPLY" },
    { name: "Century Textiles & Industries Limited", symbol: "CENTURYTEX" },
    { name: "Cera Sanitaryware Limited", symbol: "CERA" },
    { name: "Cerebra Integrated Technologies Limited", symbol: "CEREBRAINT" },
    { name: "CESC Limited", symbol: "CESC" },
    { name: "Capri Global Capital Limited", symbol: "CGCL" },
    { name: "CG Power and Industrial Solutions Limited", symbol: "CGPOWER" },
    { name: "Chalet Hotels Limited", symbol: "CHALET" },
    { name: "Chambal Fertilizers & Chemicals Limited", symbol: "CHAMBLFERT" },
    { name: "Chembond Chemicals Ltd", symbol: "CHEMBOND" },
    { name: "Chemcon Speciality Chemicals Limited", symbol: "CHEMCON" },
    { name: "Chemfab Alkalis Limited", symbol: "CHEMFAB" },
    { name: "Chemplast Sanmar Limited", symbol: "CHEMPLASTS" },
    { name: "Chennai Petroleum Corporation Limited", symbol: "CHENNPETRO" },
    { name: "Cheviot Company Limited", symbol: "CHEVIOT" },
    { name: "Choice International Limited", symbol: "CHOICEIN" },
    {
      name: "Cholamandalam Investment and Finance Company Limited",
      symbol: "CHOLAFIN",
    },
    {
      name: "Cholamandalam Financial Holdings Limited",
      symbol: "CHOLAHLDNG",
    },
    { name: "Cigniti Technologies Limited", symbol: "CIGNITITEC" },
    { name: "Cineline India Limited", symbol: "CINELINE" },
    { name: "Cinevista Limited", symbol: "CINEVISTA" },
    { name: "Cipla Limited", symbol: "CIPLA" },
    { name: "Clean Science and Technology Limited", symbol: "CLEAN" },
    { name: "CL Educate Limited", symbol: "CLEDUCATE" },
    { name: "Clariant Chemicals (India) Limited", symbol: "CLNINDIA" },
    { name: "Chaman Lal Setia Exports Limited", symbol: "CLSEL" },
    { name: "CMI Limited", symbol: "CMICABLES" },
    { name: "CMS Info Systems Limited", symbol: "CMSINFO" },
    { name: "Coal India Limited", symbol: "COALINDIA" },
    { name: "Coastal Corporation Limited", symbol: "COASTCORP" },
    { name: "Cochin Shipyard Limited", symbol: "COCHINSHIP" },
    { name: "Coffee Day Enterprises Limited", symbol: "COFFEEDAY" },
    { name: "Coforge Limited", symbol: "COFORGE" },
    { name: "Colgate Palmolive (India) Limited", symbol: "COLPAL" },
    { name: "Compuage Infocom Limited", symbol: "COMPINFO" },
    { name: "Compucom Software Limited", symbol: "COMPUSOFT" },
    { name: "Container Corporation of India Limited", symbol: "CONCOR" },
    { name: "Confidence Petroleum India Limited", symbol: "CONFIPET" },
    { name: "Consolidated Finvest & Holdings Limited", symbol: "CONSOFINVT" },
    { name: "Control Print Limited", symbol: "CONTROLPR" },
    { name: "Coral India Finance & Housing Limited", symbol: "CORALFINAC" },
    { name: "Cords Cable Industries Limited", symbol: "CORDSCABLE" },
    { name: "Coromandel International Limited", symbol: "COROMANDEL" },
    { name: "COSMO FIRST LIMITED", symbol: "COSMOFIRST" },
    { name: "Country Condo's Limited", symbol: "COUNCODOS" },
    { name: "Craftsman Automation Limited", symbol: "CRAFTSMAN" },
    { name: "Creative Newtech Limited", symbol: "CREATIVE" },
    { name: "Creative Eye Limited", symbol: "CREATIVEYE" },
    { name: "CREDITACCESS GRAMEEN LIMITED", symbol: "CREDITACC" },
    { name: "Crest Ventures Limited", symbol: "CREST" },
    { name: "CRISIL Limited", symbol: "CRISIL" },
    {
      name: "Crompton Greaves Consumer Electricals Limited",
      symbol: "CROMPTON",
    },
    { name: "Crown Lifters Limited", symbol: "CROWN" },
    { name: "CSB Bank Limited", symbol: "CSBBANK" },
    { name: "CSL Finance Limited", symbol: "CSLFINANCE" },
    { name: "Cambridge Technology Enterprises Limited", symbol: "CTE" },
    { name: "City Union Bank Limited", symbol: "CUB" },
    { name: "Cubex Tubings Limited", symbol: "CUBEXTUB" },
    { name: "Cummins India Limited", symbol: "CUMMINSIND" },
    { name: "Cupid Limited", symbol: "CUPID" },
    { name: "Cyber Media (India) Limited", symbol: "CYBERMEDIA" },
    { name: "Cybertech Systems And Software Limited", symbol: "CYBERTECH" },
    { name: "Cyient Limited", symbol: "CYIENT" },
    { name: "LT Foods Limited", symbol: "DAAWAT" },
    { name: "Dabur India Limited", symbol: "DABUR" },
    { name: "Dalmia Bharat Limited", symbol: "DALBHARAT" },
    {
      name: "Dalmia Bharat Sugar and Industries Limited",
      symbol: "DALMIASUG",
    },
    { name: "Damodar Industries Limited", symbol: "DAMODARIND" },
    { name: "Dangee Dums Limited", symbol: "DANGEE" },
    { name: "Datamatics Global Services Limited", symbol: "DATAMATICS" },
    { name: "Data Patterns (India) Limited", symbol: "DATAPATTNS" },
    { name: "D.B.Corp Limited", symbol: "DBCORP" },
    { name: "Dilip Buildcon Limited", symbol: "DBL" },
    { name: "Dhampur Bio Organics Limited", symbol: "DBOL" },
    { name: "D B Realty Limited", symbol: "DBREALTY" },
    {
      name: "DB (International) Stock Brokers Limited",
      symbol: "DBSTOCKBRO",
    },
    { name: "Dishman Carbogen Amcis Limited", symbol: "DCAL" },
    { name: "DCB Bank Limited", symbol: "DCBBANK" },
    { name: "Dc Infotech And Communication Limited", symbol: "DCI" },
    { name: "DCM  Limited", symbol: "DCM" },
    { name: "DCM Financial Services Limited", symbol: "DCMFINSERV" },
    { name: "DCM Nouvelle Limited", symbol: "DCMNVL" },
    { name: "DCM Shriram Limited", symbol: "DCMSHRIRAM" },
    { name: "DCM Shriram Industries Limited", symbol: "DCMSRIND" },
    { name: "DCW Limited", symbol: "DCW" },
    { name: "DCX Systems Limited", symbol: "DCXINDIA" },
    { name: "Deccan Cements Limited", symbol: "DECCANCE" },
    {
      name: "Deepak Fertilizers and Petrochemicals Corporation Limited",
      symbol: "DEEPAKFERT",
    },
    { name: "Deepak Nitrite Limited", symbol: "DEEPAKNTR" },
    { name: "DEEP ENERGY RESOURCES LIMITED", symbol: "DEEPENR" },
    { name: "Deep Industries Limited", symbol: "DEEPINDS" },
    { name: "Delhivery Limited", symbol: "DELHIVERY" },
    { name: "DELPHI WORLD MONEY LIMITED", symbol: "DELPHIFX" },
    { name: "Delta Corp Limited", symbol: "DELTACORP" },
    { name: "Delta Manufacturing Limited", symbol: "DELTAMAGNT" },
    { name: "Den Networks Limited", symbol: "DEN" },
    { name: "De Nora India Limited", symbol: "DENORA" },
    { name: "Dev Information Technology Limited", symbol: "DEVIT" },
    { name: "Devyani International Limited", symbol: "DEVYANI" },
    { name: "DFM Foods Limited", symbol: "DFMFOODS" },
    { name: "Digicontent Limited", symbol: "DGCONTENT" },
    { name: "Dhampur Sugar Mills Limited", symbol: "DHAMPURSUG" },
    { name: "Dhanlaxmi Bank Limited", symbol: "DHANBANK" },
    { name: "Dhani Services Limited", symbol: "DHANI" },
    { name: "Dhanuka Agritech Limited", symbol: "DHANUKA" },
    { name: "Dharmaj Crop Guard Limited", symbol: "DHARMAJ" },
    { name: "Dharani Sugars&Chemicals Limited", symbol: "DHARSUGAR" },
    { name: "Dhruv Consultancy Services Limited", symbol: "DHRUV" },
    { name: "Dhunseri Investments Limited", symbol: "DHUNINV" },
    { name: "Prataap Snacks Limited", symbol: "DIAMONDYD" },
    { name: "DIC India Limited", symbol: "DICIND" },
    { name: "DiGiSPICE Technologies Limited", symbol: "DIGISPICE" },
    { name: "Digjam Limited", symbol: "DIGJAMLMTD" },
    { name: "Debock Industries Limited", symbol: "DIL" },
    { name: "Dish TV India Limited", symbol: "DISHTV" },
    { name: "Divi's Laboratories Limited", symbol: "DIVISLAB" },
    { name: "Dixon Technologies (India) Limited", symbol: "DIXON" },
    { name: "DJ Mediaprint & Logistics Limited", symbol: "DJML" },
    { name: "DLF Limited", symbol: "DLF" },
    { name: "D-Link (India) Limited", symbol: "DLINKINDIA" },
    { name: "Avenue Supermarts Limited", symbol: "DMART" },
    { name: "DMCC SPECIALITY CHEMICALS LIMITED", symbol: "DMCC" },
    { name: "Diligent Media Corporation Limited", symbol: "DNAMEDIA" },
    { name: "Dodla Dairy Limited", symbol: "DODLA" },
    { name: "Dolat Algotech Limited", symbol: "DOLATALGO" },
    { name: "Dollar Industries Limited", symbol: "DOLLAR" },
    { name: "Donear Industries Limited", symbol: "DONEAR" },
    { name: "D. P. Abhushan Limited", symbol: "DPABHUSHAN" },
    { name: "DPSC Limited", symbol: "DPSCLTD" },
    { name: "D P Wires Limited", symbol: "DPWIRES" },
    { name: "Dreamfolks Services Limited", symbol: "DREAMFOLKS" },
    { name: "Dredging Corporation of India Limited", symbol: "DREDGECORP" },
    { name: "Dr. Reddy's Laboratories Limited", symbol: "DRREDDY" },
    { name: "Dynacons Systems & Solutions Limited", symbol: "DSSL" },
    { name: "Dhunseri Tea & Industries Limited", symbol: "DTIL" },
    { name: "Ducon Infratechnologies Limited", symbol: "DUCON" },
    { name: "Dhunseri Ventures Limited", symbol: "DVL" },
    { name: "Dwarikesh Sugar Industries Limited", symbol: "DWARKESH" },
    { name: "Dynamic Cables Limited", symbol: "DYCL" },
    { name: "Dynamatic Technologies Limited", symbol: "DYNAMATECH" },
    { name: "Dynemic Products Limited", symbol: "DYNPRO" },
    { name: "E2E Networks Limited", symbol: "E2E" },
    { name: "Easy Trip Planners Limited", symbol: "EASEMYTRIP" },
    { name: "Eastern Silk Industries Limited", symbol: "EASTSILK" },
    { name: "eClerx Services Limited", symbol: "ECLERX" },
    { name: "Edelweiss Financial Services Limited", symbol: "EDELWEISS" },
    { name: "Educomp Solutions Limited", symbol: "EDUCOMP" },
    { name: "Eicher Motors Limited", symbol: "EICHERMOT" },
    { name: "EID Parry India Limited", symbol: "EIDPARRY" },
    { name: "Euro India Fresh Foods Limited", symbol: "EIFFL" },
    { name: "EIH Associated Hotels Limited", symbol: "EIHAHOTELS" },
    { name: "EIH Limited", symbol: "EIHOTEL" },
    { name: "Eimco Elecon (India) Limited", symbol: "EIMCOELECO" },
    { name: "Everest Kanto Cylinder Limited", symbol: "EKC" },
    { name: "Eldeco Housing And Industries Limited", symbol: "ELDEHSG" },
    { name: "Elecon Engineering Company Limited", symbol: "ELECON" },
    { name: "Electrosteel Castings Limited", symbol: "ELECTCAST" },
    { name: "Electrotherm (India) Limited", symbol: "ELECTHERM" },
    { name: "Elgi Equipments Limited", symbol: "ELGIEQUIP" },
    { name: "Elgi Rubber Company Limited", symbol: "ELGIRUBCO" },
    { name: "Elin Electronics Limited", symbol: "ELIN" },
    { name: "Emami Limited", symbol: "EMAMILTD" },
    { name: "Emami Paper Mills Limited", symbol: "EMAMIPAP" },
    { name: "Emami Realty Limited", symbol: "EMAMIREAL" },
    { name: "Electronics Mart India Limited", symbol: "EMIL" },
    { name: "Emkay Global Financial Services Limited", symbol: "EMKAY" },
    { name: "Emmbi Industries Limited", symbol: "EMMBI" },
    { name: "eMudhra Limited", symbol: "EMUDHRA" },
    { name: "Endurance Technologies Limited", symbol: "ENDURANCE" },
    { name: "Energy Development Company Limited", symbol: "ENERGYDEV" },
    { name: "Engineers India Limited", symbol: "ENGINERSIN" },
    { name: "Entertainment Network (India) Limited", symbol: "ENIL" },
    { name: "EPL Limited", symbol: "EPL" },
    { name: "Equippp Social Impact Technologies Limited", symbol: "EQUIPPP" },
    { name: "Equitas Holdings Limited", symbol: "EQUITAS" },
    { name: "Equitas Small Finance Bank Limited", symbol: "EQUITASBNK" },
    { name: "Eris Lifesciences Limited", symbol: "ERIS" },
    { name: "Eros International Media Limited", symbol: "EROSMEDIA" },
    { name: "Esab India Limited", symbol: "ESABINDIA" },
    { name: "Escorts Kubota Limited", symbol: "ESCORTS" },
    { name: "Essar Shipping Limited", symbol: "ESSARSHPNG" },
    { name: "Integra Essentia Limited", symbol: "ESSENTIA" },
    { name: "Ester Industries Limited", symbol: "ESTER" },
    { name: "Ethos Limited", symbol: "ETHOSLTD" },
    { name: "Eveready Industries India Limited", symbol: "EVEREADY" },
    { name: "Everest Industries Limited", symbol: "EVERESTIND" },
    { name: "Excel Realty N Infra Limited", symbol: "EXCEL" },
    { name: "Excel Industries Limited", symbol: "EXCELINDUS" },
    { name: "Exide Industries Limited", symbol: "EXIDEIND" },
    { name: "Expleo Solutions Limited", symbol: "EXPLEOSOL" },
    { name: "Exxaro Tiles Limited", symbol: "EXXARO" },
    { name: "Fertilizers and Chemicals Travancore Limited", symbol: "FACT" },
    { name: "Fairchem Organics Limited", symbol: "FAIRCHEMOR" },
    { name: "Faze Three Limited", symbol: "FAZE3Q" },
    { name: "Fineotex Chemical Limited", symbol: "FCL" },
    { name: "Future Consumer Limited", symbol: "FCONSUMER" },
    { name: "FCS Software Solutions Limited", symbol: "FCSSOFT" },
    { name: "FDC Limited", symbol: "FDC" },
    { name: "The Federal Bank  Limited", symbol: "FEDERALBNK" },
    { name: "Future Enterprises Limited", symbol: "FEL" },
    { name: "Future Enterprises Limited", symbol: "FELDVR" },
    { name: "Fiberweb (India) Limited", symbol: "FIBERWEB" },
    { name: "Fiem Industries Limited", symbol: "FIEMIND" },
    { name: "Filatex India Limited", symbol: "FILATEX" },
    { name: "Finolex Cables Limited", symbol: "FINCABLES" },
    { name: "Fine Organic Industries Limited", symbol: "FINEORG" },
    { name: "Fino Payments Bank Limited", symbol: "FINOPB" },
    { name: "Finolex Industries Limited", symbol: "FINPIPE" },
    { name: "Five-Star Business Finance Limited", symbol: "FIVESTAR" },
    { name: "Flexituff Ventures International Limited", symbol: "FLEXITUFF" },
    { name: "Future Lifestyle Fashions Limited", symbol: "FLFL" },
    { name: "Gujarat Fluorochemicals Limited", symbol: "FLUOROCHEM" },
    { name: "Federal-Mogul Goetze (India) Limited.", symbol: "FMGOETZE" },
    { name: "Future Market Networks Limited", symbol: "FMNL" },
    { name: "Focus Lighting and Fixtures Limited", symbol: "FOCUS" },
    { name: "Foods & Inns Limited", symbol: "FOODSIN" },
    { name: "FORCE MOTORS LTD", symbol: "FORCEMOT" },
    { name: "Fortis Healthcare Limited", symbol: "FORTIS" },
    { name: "Foseco India Limited", symbol: "FOSECOIND" },
    { name: "Future Supply Chain Solutions Limited", symbol: "FSC" },
    { name: "Firstsource Solutions Limited", symbol: "FSL" },
    { name: "Fusion Micro Finance Limited", symbol: "FUSION" },
    { name: "Gabriel India Limited", symbol: "GABRIEL" },
    { name: "Gujarat Ambuja Exports Limited", symbol: "GAEL" },
    { name: "GAIL (India) Limited", symbol: "GAIL" },
    { name: "Gyscoal Alloys Limited", symbol: "GAL" },
    { name: "Galaxy Surfactants Limited", symbol: "GALAXYSURF" },
    { name: "Gallantt Ispat Limited", symbol: "GALLANTT" },
    { name: "Gandhi Special Tubes Limited", symbol: "GANDHITUBE" },
    { name: "Ganesha Ecosphere Limited", symbol: "GANECOS" },
    { name: "Ganesh Benzoplast Limited", symbol: "GANESHBE" },
    { name: "Ganesh Housing Corporation Limited", symbol: "GANESHHOUC" },
    { name: "Ganga Forging Limited", symbol: "GANGAFORGE" },
    { name: "Ganges Securities Limited", symbol: "GANGESSECU" },
    { name: "Garware Technical Fibres Limited", symbol: "GARFIBRES" },
    { name: "Gateway Distriparks Limited", symbol: "GATEWAY" },
    { name: "GATI Limited", symbol: "GATI" },
    { name: "Gayatri Highways Limited", symbol: "GAYAHWS" },
    { name: "Gayatri Projects Limited", symbol: "GAYAPROJ" },
    { name: "GeeCee Ventures Limited", symbol: "GEECEE" },
    { name: "Geekay Wires Limited", symbol: "GEEKAYWIRE" },
    {
      name: "Generic Engineering Construction and Projects Limited",
      symbol: "GENCON",
    },
    { name: "Genesys International Corporation Limited", symbol: "GENESYS" },
    { name: "Genus Paper & Boards Limited", symbol: "GENUSPAPER" },
    { name: "Genus Power Infrastructures Limited", symbol: "GENUSPOWER" },
    { name: "Geojit Financial Services Limited", symbol: "GEOJITFSL" },
    { name: "GE Power India Limited", symbol: "GEPIL" },
    { name: "The Great Eastern Shipping Company Limited", symbol: "GESHIP" },
    { name: "GE T&D India Limited", symbol: "GET&D" },
    { name: "GFL Limited", symbol: "GFLLIMITED" },
    { name: "GHCL Limited", symbol: "GHCL" },
    { name: "GIC Housing Finance Limited", symbol: "GICHSGFIN" },
    { name: "General Insurance Corporation of India", symbol: "GICRE" },
    { name: "Gillanders Arbuthnot & Company Limited", symbol: "GILLANDERS" },
    { name: "Gillette India Limited", symbol: "GILLETTE" },
    { name: "Ginni Filaments Limited", symbol: "GINNIFILA" },
    { name: "Gujarat Industries Power Company Limited", symbol: "GIPCL" },
    { name: "GKW Limited", symbol: "GKWLIMITED" },
    { name: "Gland Pharma Limited", symbol: "GLAND" },
    { name: "GlaxoSmithKline Pharmaceuticals Limited", symbol: "GLAXO" },
    { name: "Glenmark Pharmaceuticals Limited", symbol: "GLENMARK" },
    { name: "Gujarat Lease Financing Limited", symbol: "GLFL" },
    { name: "Global Education Limited", symbol: "GLOBAL" },
    { name: "Global Vectra Helicorp Limited", symbol: "GLOBALVECT" },
    { name: "Globe Textiles (India) Limited", symbol: "GLOBE" },
    { name: "Globus Spirits Limited", symbol: "GLOBUSSPR" },
    { name: "Glenmark Life Sciences Limited", symbol: "GLS" },
    { name: "GM Breweries Limited", symbol: "GMBREW" },
    {
      name: "Gujarat Mineral Development Corporation Limited",
      symbol: "GMDCLTD",
    },
    { name: "GMM Pfaudler Limited", symbol: "GMMPFAUDLR" },
    { name: "GMR Airports Infrastructure Limited", symbol: "GMRINFRA" },
    { name: "GMR Power and Urban Infra Limited", symbol: "GMRP&UI" },
    { name: "GNA Axles Limited", symbol: "GNA" },
    {
      name: "Gujarat Narmada Valley Fertilizers and Chemicals Limited",
      symbol: "GNFC",
    },
    { name: "Goa Carbon Limited", symbol: "GOACARBON" },
    { name: "GOCL Corporation Limited", symbol: "GOCLCORP" },
    { name: "Go Fashion (India) Limited", symbol: "GOCOLORS" },
    { name: "Godfrey Phillips India Limited", symbol: "GODFRYPHLP" },
    { name: "Godha Cabcon & Insulation Limited", symbol: "GODHA" },
    { name: "Godrej Agrovet Limited", symbol: "GODREJAGRO" },
    { name: "Godrej Consumer Products Limited", symbol: "GODREJCP" },
    { name: "Godrej Industries Limited", symbol: "GODREJIND" },
    { name: "Godrej Properties Limited", symbol: "GODREJPROP" },
    { name: "Goenka Diamond and Jewels Limited", symbol: "GOENKA" },
    { name: "Gokaldas Exports Limited", symbol: "GOKEX" },
    { name: "Gokul Refoils and Solvent Limited", symbol: "GOKUL" },
    { name: "Gokul Agro Resources Limited", symbol: "GOKULAGRO" },
    { name: "Golden Tobacco Limited", symbol: "GOLDENTOBC" },
    { name: "Goldiam International Limited", symbol: "GOLDIAM" },
    { name: "Goldstone Technologies Limited", symbol: "GOLDTECH" },
    { name: "Goodluck India Limited", symbol: "GOODLUCK" },
    { name: "Goodyear India Limited", symbol: "GOODYEAR" },
    { name: "Goyal Aluminiums Limited", symbol: "GOYALALUM" },
    { name: "Godawari Power And Ispat limited", symbol: "GPIL" },
    { name: "Gujarat Pipavav Port Limited", symbol: "GPPL" },
    { name: "GPT Infraprojects Limited", symbol: "GPTINFRA" },
    { name: "Granules India Limited", symbol: "GRANULES" },
    { name: "Graphite India Limited", symbol: "GRAPHITE" },
    { name: "Grasim Industries Limited", symbol: "GRASIM" },
    { name: "Grauer & Weil (India) Limited", symbol: "GRAUWEIL" },
    { name: "Gravita India Limited", symbol: "GRAVITA" },
    { name: "Greaves Cotton Limited", symbol: "GREAVESCOT" },
    { name: "Greenlam Industries Limited", symbol: "GREENLAM" },
    { name: "Greenpanel Industries Limited", symbol: "GREENPANEL" },
    { name: "Greenply Industries Limited", symbol: "GREENPLY" },
    { name: "Orient Green Power Company Limited", symbol: "GREENPOWER" },
    { name: "Grindwell Norton Limited", symbol: "GRINDWELL" },
    { name: "G R Infraprojects Limited", symbol: "GRINFRA" },
    { name: "GRM Overseas Limited", symbol: "GRMOVER" },
    { name: "The Grob Tea Company Limited", symbol: "GROBTEA" },
    { name: "GRP Limited", symbol: "GRPLTD" },
    { name: "Garden Reach Shipbuilders & Engineers Limited", symbol: "GRSE" },
    { name: "Garware Hi-Tech Films Limited", symbol: "GRWRHITECH" },
    { name: "Gujarat Sidhee Cement Limited", symbol: "GSCLCEMENT" },
    { name: "Gujarat State Fertilizers & Chemicals Limited", symbol: "GSFC" },
    { name: "Gujarat State Petronet Limited", symbol: "GSPL" },
    { name: "GSS Infotech Limited", symbol: "GSS" },
    { name: "GTL Limited", symbol: "GTL" },
    { name: "GTL Infrastructure Limited", symbol: "GTLINFRA" },
    { name: "GTPL Hathway Limited", symbol: "GTPL" },
    { name: "Gufic Biosciences Limited", symbol: "GUFICBIO" },
    { name: "Gujarat Alkalies and Chemicals Limited", symbol: "GUJALKALI" },
    { name: "Gujarat Apollo Industries Limited", symbol: "GUJAPOLLO" },
    { name: "Gujarat Gas Limited", symbol: "GUJGASLTD" },
    { name: "Gujarat Raffia Industries Limited", symbol: "GUJRAFFIA" },
    { name: "Gulf Oil Lubricants India Limited", symbol: "GULFOILLUB" },
    { name: "GP Petroleums Limited", symbol: "GULFPETRO" },
    { name: "Gulshan Polyols Limited", symbol: "GULPOLY" },
    { name: "GVK Power & Infrastructure Limited", symbol: "GVKPIL" },
    { name: "Hindustan Aeronautics Limited", symbol: "HAL" },
    { name: "Happiest Minds Technologies Limited", symbol: "HAPPSTMNDS" },
    { name: "Hardwyn India Limited", symbol: "HARDWYN" },
    { name: "Hariom Pipe Industries Limited", symbol: "HARIOMPIPE" },
    { name: "Harrisons  Malayalam Limited", symbol: "HARRMALAYA" },
    { name: "Harsha Engineers International Limited", symbol: "HARSHA" },
    { name: "Hathway Cable & Datacom Limited", symbol: "HATHWAY" },
    { name: "Hatsun Agro Product Limited", symbol: "HATSUN" },
    { name: "Havells India Limited", symbol: "HAVELLS" },
    {
      name: "Sri Havisha Hospitality and Infrastructure Limited",
      symbol: "HAVISHA",
    },
    { name: "HBL Power Systems Limited", symbol: "HBLPOWER" },
    { name: "HB Stockholdings Limited", symbol: "HBSL" },
    { name: "Hindustan Construction Company Limited", symbol: "HCC" },
    { name: "Healthcare Global Enterprises Limited", symbol: "HCG" },
    { name: "HCL Infosystems Limited", symbol: "HCL-INSYS" },
    { name: "HCL Technologies Limited", symbol: "HCLTECH" },
    {
      name: "Housing Development Finance Corporation Limited",
      symbol: "HDFC",
    },
    { name: "HDFC Asset Management Company Limited", symbol: "HDFCAMC" },
    { name: "HDFC Bank Limited", symbol: "HDFCBANK" },
    { name: "HDFC Life Insurance Company Limited", symbol: "HDFCLIFE" },
    {
      name: "Housing Development and Infrastructure Limited",
      symbol: "HDIL",
    },
    { name: "Heads UP Ventures Limited", symbol: "HEADSUP" },
    { name: "HEC Infra Projects Limited", symbol: "HECPROJECT" },
    { name: "HEG Limited", symbol: "HEG" },
    { name: "HeidelbergCement India Limited", symbol: "HEIDELBERG" },
    { name: "Hemisphere Properties India Limited", symbol: "HEMIPROP" },
    { name: "Heranba Industries Limited", symbol: "HERANBA" },
    { name: "Hercules Hoists Limited", symbol: "HERCULES" },
    { name: "Heritage Foods Limited", symbol: "HERITGFOOD" },
    { name: "Hero MotoCorp Limited", symbol: "HEROMOTOCO" },
    { name: "Hester Biosciences Limited", symbol: "HESTERBIO" },
    { name: "Hexa Tradex Limited", symbol: "HEXATRADEX" },
    { name: "HFCL Limited", symbol: "HFCL" },
    { name: "H.G. Infra Engineering Limited", symbol: "HGINFRA" },
    { name: "Hinduja Global Solutions Limited", symbol: "HGS" },
    { name: "Hikal Limited", symbol: "HIKAL" },
    { name: "HIL Limited", symbol: "HIL" },
    { name: "Hilton Metal Forging Limited", symbol: "HILTON" },
    { name: "Himatsingka Seide Limited", symbol: "HIMATSEIDE" },
    { name: "Hindalco Industries Limited", symbol: "HINDALCO" },
    { name: "Hindustan Composites Limited", symbol: "HINDCOMPOS" },
    { name: "Hindcon Chemicals Limited", symbol: "HINDCON" },
    { name: "Hindustan Copper Limited", symbol: "HINDCOPPER" },
    { name: "Hindustan Motors Limited", symbol: "HINDMOTORS" },
    {
      name: "Hindustan Oil Exploration Company Limited",
      symbol: "HINDOILEXP",
    },
    { name: "Hindustan Petroleum Corporation Limited", symbol: "HINDPETRO" },
    { name: "Hindustan Unilever Limited", symbol: "HINDUNILVR" },
    { name: "Hindware Home Innovation Limited", symbol: "HINDWAREAP" },
    { name: "Hindustan Zinc Limited", symbol: "HINDZINC" },
    { name: "Hind Rectifiers Limited", symbol: "HIRECT" },
    { name: "Hisar Metal Industries Limited", symbol: "HISARMETAL" },
    { name: "Hi-Tech Pipes Limited", symbol: "HITECH" },
    { name: "Hitech Corporation Limited", symbol: "HITECHCORP" },
    { name: "The Hi-Tech Gears Limited", symbol: "HITECHGEAR" },
    { name: "HLE Glascoat Limited", symbol: "HLEGLAS" },
    { name: "HLV LIMITED", symbol: "HLVLTD" },
    { name: "HMT Limited", symbol: "HMT" },
    { name: "Hindustan Media Ventures Limited", symbol: "HMVL" },
    { name: "Hindustan Foods Limited", symbol: "HNDFDS" },
    { name: "Home First Finance Company India Limited", symbol: "HOMEFIRST" },
    { name: "Honeywell Automation India Limited", symbol: "HONAUT" },
    { name: "Honda India Power Products Limited", symbol: "HONDAPOWER" },
    { name: "HOV Services Limited", symbol: "HOVS" },
    { name: "HP Adhesives Limited", symbol: "HPAL" },
    { name: "Hindprakash Industries Limited", symbol: "HPIL" },
    { name: "HPL Electric & Power Limited", symbol: "HPL" },
    { name: "Himadri Speciality Chemical Limited", symbol: "HSCL" },
    { name: "HT Media Limited", symbol: "HTMEDIA" },
    { name: "Hubtown Limited", symbol: "HUBTOWN" },
    {
      name: "Housing & Urban Development Corporation Limited",
      symbol: "HUDCO",
    },
    { name: "Huhtamaki India Limited", symbol: "HUHTAMAKI" },
    { name: "Hybrid Financial Services Limited", symbol: "HYBRIDFIN" },
    { name: "Indiabulls Real Estate Limited", symbol: "IBREALEST" },
    { name: "Indiabulls Housing Finance Limited", symbol: "IBULHSGFIN" },
    { name: "ICDS Limited", symbol: "ICDSLTD" },
    { name: "Ice Make Refrigeration Limited", symbol: "ICEMAKE" },
    { name: "ICICI Bank Limited", symbol: "ICICIBANK" },
    {
      name: "ICICI Lombard General Insurance Company Limited",
      symbol: "ICICIGI",
    },
    {
      name: "ICICI Prudential Life Insurance Company Limited",
      symbol: "ICICIPRULI",
    },
    { name: "Indo Count Industries Limited", symbol: "ICIL" },
    { name: "ICRA Limited", symbol: "ICRA" },
    { name: "IDBI Bank Limited", symbol: "IDBI" },
    { name: "Vodafone Idea Limited", symbol: "IDEA" },
    { name: "IDFC Limited", symbol: "IDFC" },
    { name: "IDFC First Bank Limited", symbol: "IDFCFIRSTB" },
    { name: "Indiabulls Enterprises Limited", symbol: "IEL" },
    { name: "Indian Energy Exchange Limited", symbol: "IEX" },
    { name: "IFB Agro Industries Limited", symbol: "IFBAGRO" },
    { name: "IFB Industries Limited", symbol: "IFBIND" },
    { name: "IFCI Limited", symbol: "IFCI" },
    { name: "IFGL Refractories Limited", symbol: "IFGLEXPOR" },
    { name: "Igarashi Motors India Limited", symbol: "IGARASHI" },
    { name: "Indraprastha Gas Limited", symbol: "IGL" },
    { name: "IG Petrochemicals Limited", symbol: "IGPL" },
    { name: "IIFL Finance Limited", symbol: "IIFL" },
    { name: "IIFL Securities Limited", symbol: "IIFLSEC" },
    { name: "Iifl Wealth Management Limited", symbol: "IIFLWAM" },
    { name: "Industrial Investment Trust Limited", symbol: "IITL" },
    {
      name: "IL&FS Engineering and Construction Company Limited",
      symbol: "IL&FSENGG",
    },
    { name: "IL&FS Transportation Networks Limited", symbol: "IL&FSTRANS" },
    { name: "Imagicaaworld Entertainment Limited", symbol: "IMAGICAA" },
    { name: "Indian Metals & Ferro Alloys Limited", symbol: "IMFA" },
    { name: "India Motor Parts and Accessories Limited", symbol: "IMPAL" },
    { name: "INCREDIBLE INDUSTRIES LIMITED", symbol: "INCREDIBLE" },
    { name: "Indbank Merchant Banking Services Limited", symbol: "INDBANK" },
    { name: "The Indian Hotels Company Limited", symbol: "INDHOTEL" },
    { name: "The India Cements Limited", symbol: "INDIACEM" },
    { name: "India Glycols Limited", symbol: "INDIAGLYCO" },
    { name: "Indiamart Intermesh Limited", symbol: "INDIAMART" },
    { name: "Indian Bank", symbol: "INDIANB" },
    { name: "Indian Card Clothing Company Limited", symbol: "INDIANCARD" },
    { name: "Indian Hume Pipe Company Limited", symbol: "INDIANHUME" },
    { name: "InterGlobe Aviation Limited", symbol: "INDIGO" },
    { name: "Indigo Paints Limited", symbol: "INDIGOPNTS" },
    { name: "IMP Powers Limited", symbol: "INDLMETER" },
    { name: "India Nippon Electricals Limited", symbol: "INDNIPPON" },
    { name: "Indo Amines Limited", symbol: "INDOAMIN" },
    { name: "Indo Borax & Chemicals Limited", symbol: "INDOBORAX" },
    { name: "Indoco Remedies Limited", symbol: "INDOCO" },
    { name: "Indo Rama Synthetics (India) Limited", symbol: "INDORAMA" },
    { name: "IndoStar Capital Finance Limited", symbol: "INDOSTAR" },
    { name: "Indo Tech Transformers Limited", symbol: "INDOTECH" },
    { name: "Indo Thai Securities Limited", symbol: "INDOTHAI" },
    { name: "Indowind Energy Limited", symbol: "INDOWIND" },
    {
      name: "Indraprastha Medical Corporation Limited",
      symbol: "INDRAMEDCO",
    },
    { name: "Ind-Swift Laboratories Limited", symbol: "INDSWFTLAB" },
    { name: "Ind-Swift Limited", symbol: "INDSWFTLTD" },
    { name: "Indian Terrain Fashions Limited", symbol: "INDTERRAIN" },
    { name: "IndusInd Bank Limited", symbol: "INDUSINDBK" },
    { name: "Indus Towers Limited", symbol: "INDUSTOWER" },
    { name: "Infibeam Avenues Limited", symbol: "INFIBEAM" },
    { name: "InfoBeans Technologies Limited", symbol: "INFOBEAN" },
    { name: "Infomedia Press Limited", symbol: "INFOMEDIA" },
    { name: "Infosys Limited", symbol: "INFY" },
    { name: "Ingersoll Rand (India) Limited", symbol: "INGERRAND" },
    { name: "Inox Green Energy Services Limited", symbol: "INOXGREEN" },
    { name: "INOX Leisure Limited", symbol: "INOXLEISUR" },
    { name: "Inox Wind Limited", symbol: "INOXWIND" },
    { name: "Insecticides (India) Limited", symbol: "INSECTICID" },
    { name: "Inspirisys Solutions Limited", symbol: "INSPIRISYS" },
    { name: "Intellect Design Arena Limited", symbol: "INTELLECT" },
    { name: "Intense Technologies Limited", symbol: "INTENTECH" },
    { name: "International Conveyors Limited", symbol: "INTLCONV" },
    { name: "Inventure Growth & Securities Limited", symbol: "INVENTURE" },
    { name: "Indian Overseas Bank", symbol: "IOB" },
    { name: "Indian Oil Corporation Limited", symbol: "IOC" },
    { name: "IOL Chemicals and Pharmaceuticals Limited", symbol: "IOLCP" },
    { name: "ION Exchange (India) Limited", symbol: "IONEXCHANG" },
    { name: "IPCA Laboratories Limited", symbol: "IPCALAB" },
    { name: "India Pesticides Limited", symbol: "IPL" },
    { name: "IRB Infrastructure Developers Limited", symbol: "IRB" },
    { name: "Ircon International Limited", symbol: "IRCON" },
    {
      name: "Indian Railway Catering And Tourism Corporation Limited",
      symbol: "IRCTC",
    },
    { name: "Indian Railway Finance Corporation Limited", symbol: "IRFC" },
    { name: "Iris Business Services Limited", symbol: "IRIS" },
    { name: "Iris Clothings Limited", symbol: "IRISDOREME" },
    { name: "ICICI Securities Limited", symbol: "ISEC" },
    { name: "Intrasoft Technologies Limited", symbol: "ISFT" },
    { name: "Isgec Heavy Engineering Limited", symbol: "ISGEC" },
    { name: "ISMT Limited", symbol: "ISMTLTD" },
    { name: "ITC Limited", symbol: "ITC" },
    { name: "India Tourism Development Corporation Limited", symbol: "ITDC" },
    { name: "ITD Cementation India Limited", symbol: "ITDCEM" },
    { name: "ITI Limited", symbol: "ITI" },
    { name: "IL&FS Investment Managers Limited", symbol: "IVC" },
    { name: "IVP Limited", symbol: "IVP" },
    { name: "Inox Wind Energy Limited", symbol: "IWEL" },
    { name: "IZMO Limited", symbol: "IZMO" },
    { name: "The Jammu & Kashmir Bank Limited", symbol: "J&KBANK" },
    { name: "Jagran Prakashan Limited", symbol: "JAGRAN" },
    { name: "Jagsonpal Pharmaceuticals Limited", symbol: "JAGSNPHARM" },
    { name: "Jai Balaji Industries Limited", symbol: "JAIBALAJI" },
    { name: "Jai Corp Limited", symbol: "JAICORPLTD" },
    { name: "Nandani Creation Limited", symbol: "JAIPURKURT" },
    { name: "Jamna Auto Industries Limited", symbol: "JAMNAAUTO" },
    { name: "Jash Engineering Limited", symbol: "JASH" },
    { name: "Jayant Agro Organics Limited", symbol: "JAYAGROGN" },
    { name: "Jay Bharat Maruti Limited", symbol: "JAYBARMARU" },
    { name: "Jayaswal Neco Industries Limited", symbol: "JAYNECOIND" },
    { name: "Jayshree Tea & Industries Limited", symbol: "JAYSREETEA" },
    { name: "JB Chemicals & Pharmaceuticals Limited", symbol: "JBCHEPHARM" },
    { name: "JBF Industries Limited", symbol: "JBFIND" },
    { name: "JBM Auto Limited", symbol: "JBMA" },
    {
      name: "Johnson Controls - Hitachi Air Conditioning India Limited",
      symbol: "JCHAC",
    },
    { name: "Jet Airways (India) Limited", symbol: "JETAIRWAYS" },
    { name: "Jet Freight Log Ltd-RE", symbol: "JETFRE-RE" },
    { name: "Jet Freight Logistics Limited", symbol: "JETFREIGHT" },
    { name: "JHS Svendgaard Laboratories Limited", symbol: "JHS" },
    { name: "Jindal Photo Limited", symbol: "JINDALPHOT" },
    { name: "Jindal Poly Films Limited", symbol: "JINDALPOLY" },
    { name: "Jindal Saw Limited", symbol: "JINDALSAW" },
    { name: "Jindal Steel & Power Limited", symbol: "JINDALSTEL" },
    { name: "Jindal Drilling And Industries Limited", symbol: "JINDRILL" },
    { name: "Jindal Worldwide Limited", symbol: "JINDWORLD" },
    { name: "Jain Irrigation Systems Limited", symbol: "JISLDVREQS" },
    { name: "Jain Irrigation Systems Limited", symbol: "JISLJALEQS" },
    { name: "JITF Infralogistics Limited", symbol: "JITFINFRA" },
    { name: "JK Cement Limited", symbol: "JKCEMENT" },
    { name: "J.Kumar Infraprojects Limited", symbol: "JKIL" },
    { name: "JK Lakshmi Cement Limited", symbol: "JKLAKSHMI" },
    { name: "JK Paper Limited", symbol: "JKPAPER" },
    { name: "JK Tyre & Industries Limited", symbol: "JKTYRE" },
    { name: "Jullundur Motor Agency (Delhi) Limited", symbol: "JMA" },
    { name: "JM Financial Limited", symbol: "JMFINANCIL" },
    { name: "Jocil Limited", symbol: "JOCIL" },
    { name: "Jaiprakash Associates Limited", symbol: "JPASSOCIAT" },
    {
      name: "Jindal Poly Investment and Finance Company Limited",
      symbol: "JPOLYINVST",
    },
    { name: "Jaiprakash Power Ventures Limited", symbol: "JPPOWER" },
    { name: "Jindal Stainless Limited", symbol: "JSL" },
    { name: "Jindal Stainless (Hisar) Limited", symbol: "JSLHISAR" },
    { name: "JSW Energy Limited", symbol: "JSWENERGY" },
    { name: "JSW Holdings Limited", symbol: "JSWHL" },
    { name: "JSW Ispat Special Products Limited", symbol: "JSWISPL" },
    { name: "JSW Steel Limited", symbol: "JSWSTEEL" },
    { name: "Jtekt India Limited", symbol: "JTEKTINDIA" },
    { name: "JTL INDUSTRIES LIMITED", symbol: "JTLIND" },
    { name: "Jubilant Foodworks Limited", symbol: "JUBLFOOD" },
    { name: "Jubilant Industries Limited", symbol: "JUBLINDS" },
    { name: "Jubilant Ingrevia Limited", symbol: "JUBLINGREA" },
    { name: "Jubilant Pharmova Limited", symbol: "JUBLPHARMA" },
    { name: "Just Dial Limited", symbol: "JUSTDIAL" },
    { name: "Jupiter Wagons Limited", symbol: "JWL" },
    { name: "Jyothy Labs Limited", symbol: "JYOTHYLAB" },
    { name: "Jyoti Structures Limited", symbol: "JYOTISTRUC" },
    { name: "Kabra Extrusion Technik Limited", symbol: "KABRAEXTRU" },
    { name: "Kajaria Ceramics Limited", symbol: "KAJARIACER" },
    {
      name: "Kakatiya Cement Sugar & Industries Limited",
      symbol: "KAKATCEM",
    },
    { name: "Kalpataru Power Transmission Limited", symbol: "KALPATPOWR" },
    { name: "Kalyani Commercials Limited", symbol: "KALYANI" },
    { name: "Kalyani Forge Limited", symbol: "KALYANIFRG" },
    { name: "Kalyan Jewellers India Limited", symbol: "KALYANKJIL" },
    { name: "Kamat Hotels (I) Limited", symbol: "KAMATHOTEL" },
    { name: "Kamdhenu Limited", symbol: "KAMDHENU" },
    { name: "Kanani Industries Limited", symbol: "KANANIIND" },
    { name: "Kanoria Chemicals & Industries Limited", symbol: "KANORICHEM" },
    { name: "Kanpur Plastipack Limited", symbol: "KANPRPLA" },
    { name: "Kansai Nerolac Paints Limited", symbol: "KANSAINER" },
    { name: "Kapston Services Limited", symbol: "KAPSTON" },
    { name: "Karma Energy Limited", symbol: "KARMAENG" },
    { name: "Karur Vysya Bank Limited", symbol: "KARURVYSYA" },
    {
      name: "Kaushalya Infrastructure Development Corporation Limited",
      symbol: "KAUSHALYA",
    },
    { name: "Kavveri Telecom Products Limited", symbol: "KAVVERITEL" },
    { name: "Kaya Limited", symbol: "KAYA" },
    { name: "Kaynes Technology India Limited", symbol: "KAYNES" },
    { name: "KBC Global Limited", symbol: "KBCGLOBAL" },
    { name: "KCP Limited", symbol: "KCP" },
    {
      name: "KCP Sugar and Industries Corporation Limited",
      symbol: "KCPSUGIND",
    },
    { name: "KDDL Limited", symbol: "KDDL" },
    { name: "KEC International Limited", symbol: "KEC" },
    { name: "Kirloskar Electric Company Limited", symbol: "KECL" },
    { name: "DSJ Keep Learning Limited", symbol: "KEEPLEARN" },
    { name: "KEI Industries Limited", symbol: "KEI" },
    { name: "Kellton Tech Solutions Limited", symbol: "KELLTONTEC" },
    { name: "Kennametal India Limited", symbol: "KENNAMET" },
    { name: "Kernex Microsystems (India) Limited", symbol: "KERNEX" },
    { name: "Kesoram Industries Limited", symbol: "KESORAMIND" },
    { name: "Keynote Financial Services Limited", symbol: "KEYFINSERV" },
    { name: "Kfin Technologies Limited", symbol: "KFINTECH" },
    { name: "Khadim India Limited", symbol: "KHADIM" },
    { name: "Khaitan Chemicals & Fertilizers Limited", symbol: "KHAICHEM" },
    { name: "Khaitan (India) Limited", symbol: "KHAITANLTD" },
    { name: "Khandwala Securities Limited", symbol: "KHANDSE" },
    { name: "Kalyani Investment Company Limited", symbol: "KICL" },
    { name: "Kilitch Drugs (India) Limited", symbol: "KILITCH" },
    { name: "Krishna Institute of Medical Sciences Limited", symbol: "KIMS" },
    { name: "Kingfa Science & Technology (India) Limited", symbol: "KINGFA" },
    { name: "KIOCL Limited", symbol: "KIOCL" },
    { name: "Kiri Industries Limited", symbol: "KIRIINDUS" },
    { name: "Kirloskar Ferrous Industries Ltd", symbol: "KIRLFER" },
    { name: "Kirloskar Brothers Limited", symbol: "KIRLOSBROS" },
    { name: "Kirloskar Oil Engines Limited", symbol: "KIRLOSENG" },
    { name: "Kirloskar Industries Limited", symbol: "KIRLOSIND" },
    { name: "Kitex Garments Limited", symbol: "KITEX" },
    { name: "Kewal Kiran Clothing Limited", symbol: "KKCL" },
    { name: "K.M.Sugar Mills Limited", symbol: "KMSUGAR" },
    { name: "KNR Constructions Limited", symbol: "KNRCON" },
    { name: "Kohinoor Foods Limited", symbol: "KOHINOOR" },
    { name: "Kokuyo Camlin Limited", symbol: "KOKUYOCMLN" },
    { name: "Kolte - Patil Developers Limited", symbol: "KOLTEPATIL" },
    { name: "Kopran Limited", symbol: "KOPRAN" },
    { name: "Kotak Mahindra Bank Limited", symbol: "KOTAKBANK" },
    { name: "Kothari Sugars And Chemicals Limited", symbol: "KOTARISUG" },
    { name: "Kothari Petrochemicals Limited", symbol: "KOTHARIPET" },
    { name: "Kothari Products Limited", symbol: "KOTHARIPRO" },
    { name: "Kovai Medical Center and Hospital Limited", symbol: "KOVAI" },
    { name: "KPI Green Energy Limited", symbol: "KPIGREEN" },
    { name: "KPIT Technologies Limited", symbol: "KPITTECH" },
    { name: "K.P.R. Mill Limited", symbol: "KPRMILL" },
    { name: "KRBL Limited", symbol: "KRBL" },
    { name: "Krebs Biochemicals and Industries Limited", symbol: "KREBSBIO" },
    { name: "Kridhan Infra Limited", symbol: "KRIDHANINF" },
    { name: "Krishana Phoschem Limited", symbol: "KRISHANA" },
    { name: "Kriti Industries (India) Limited", symbol: "KRITI" },
    { name: "Kritika Wires Limited", symbol: "KRITIKA" },
    { name: "Kriti Nutrients Limited", symbol: "KRITINUT" },
    { name: "Krsnaa Diagnostics Limited", symbol: "KRSNAA" },
    { name: "Ksb Limited", symbol: "KSB" },
    { name: "Kaveri Seed Company Limited", symbol: "KSCL" },
    { name: "Kshitij Polyline Limited", symbol: "KSHITIJPOL" },
    { name: "Kalyani Steels Limited", symbol: "KSL" },
    { name: "Ksolves India Limited", symbol: "KSOLVES" },
    { name: "The Karnataka Bank Limited", symbol: "KTKBANK" },
    { name: "Kuantum Papers Limited", symbol: "KUANTUM" },
    { name: "L&T Finance Holdings Limited", symbol: "L&TFH" },
    { name: "Lagnam Spintex Limited", symbol: "LAGNAM" },
    { name: "Lakshmi Precision Screws Limited", symbol: "LAKPRE" },
    { name: "Dr. Lal Path Labs Ltd.", symbol: "LALPATHLAB" },
    { name: "Lambodhara Textiles Limited", symbol: "LAMBODHARA" },
    { name: "Lancer Container Lines Limited", symbol: "LANCER" },
    { name: "Landmark Cars Limited", symbol: "LANDMARK" },
    { name: "La Opala RG Limited", symbol: "LAOPALA" },
    { name: "Lasa Supergenerics Limited", symbol: "LASA" },
    { name: "Latent View Analytics Limited", symbol: "LATENTVIEW" },
    { name: "Laurus Labs Limited", symbol: "LAURUSLABS" },
    { name: "Laxmi Cotspin Limited", symbol: "LAXMICOT" },
    { name: "Lakshmi Machine Works Limited", symbol: "LAXMIMACH" },
    { name: "LCC Infotech Limited", symbol: "LCCINFOTEC" },
    { name: "Lemon Tree Hotels Limited", symbol: "LEMONTREE" },
    {
      name: "Lakshmi Finance & Industrial Corporation Limited",
      symbol: "LFIC",
    },
    { name: "LG Balakrishnan & Bros Limited", symbol: "LGBBROSLTD" },
    { name: "LGB Forge Limited", symbol: "LGBFORGE" },
    { name: "Libas Consumer Products Limited", symbol: "LIBAS" },
    { name: "Liberty Shoes Limited", symbol: "LIBERTSHOE" },
    { name: "LIC Housing Finance Limited", symbol: "LICHSGFIN" },
    { name: "Life Insurance Corporation Of India", symbol: "LICI" },
    { name: "Likhitha Infrastructure Limited", symbol: "LIKHITHA" },
    { name: "Linc Limited", symbol: "LINC" },
    { name: "Lincoln Pharmaceuticals Limited", symbol: "LINCOLN" },
    { name: "Linde India Limited", symbol: "LINDEINDIA" },
    { name: "Macrotech Developers Limited", symbol: "LODHA" },
    { name: "Lokesh Machines Limited", symbol: "LOKESHMACH" },
    { name: "Lotus Eye Hospital and Institute Limited", symbol: "LOTUSEYE" },
    { name: "Lovable Lingerie Limited", symbol: "LOVABLE" },
    { name: "Loyal Textile Mills Limited", symbol: "LOYALTEX" },
    { name: "Landmark Property Development Company Limited", symbol: "LPDC" },
    { name: "Lloyds Steels Industries Limited", symbol: "LSIL" },
    { name: "Larsen & Toubro Limited", symbol: "LT" },
    { name: "LTIMindtree Limited", symbol: "LTIM" },
    { name: "L&T Technology Services Limited", symbol: "LTTS" },
    { name: "Lumax Industries Limited", symbol: "LUMAXIND" },
    { name: "Lumax Auto Technologies Limited", symbol: "LUMAXTECH" },
    { name: "Lupin Limited", symbol: "LUPIN" },
    { name: "Lux Industries Limited", symbol: "LUXIND" },
    { name: "Laxmi Organic Industries Limited", symbol: "LXCHEM" },
    { name: "Lyka Labs Limited", symbol: "LYKALABS" },
    { name: "Lypsa Gems & Jewellery Limited", symbol: "LYPSAGEMS" },
    { name: "Mahindra & Mahindra Limited", symbol: "M&M" },
    {
      name: "Mahindra & Mahindra Financial Services Limited",
      symbol: "M&MFIN",
    },
    { name: "Maan Aluminium Limited", symbol: "MAANALU" },
    { name: "Macpower CNC Machines Limited", symbol: "MACPOWER" },
    { name: "Madhav Marbles and Granites Limited", symbol: "MADHAV" },
    { name: "Madhucon Projects Limited", symbol: "MADHUCON" },
    { name: "Madras Fertilizers Limited", symbol: "MADRASFERT" },
    { name: "Magadh Sugar & Energy Limited", symbol: "MAGADSUGAR" },
    { name: "Magnum Ventures Limited", symbol: "MAGNUM" },
    { name: "Bank of Maharashtra", symbol: "MAHABANK" },
    { name: "Maha Rashtra Apex Corporation Limited", symbol: "MAHAPEXLTD" },
    { name: "Mahamaya Steel Industries Limited", symbol: "MAHASTEEL" },
    { name: "Mahindra EPC Irrigation Limited", symbol: "MAHEPC" },
    { name: "Maheshwari Logistics Limited", symbol: "MAHESHWARI" },
    { name: "Mahindra CIE Automotive Limited", symbol: "MAHINDCIE" },
    { name: "Mahindra Lifespace Developers Limited", symbol: "MAHLIFE" },
    { name: "Mahindra Logistics Limited", symbol: "MAHLOG" },
    { name: "Maharashtra Scooters Limited", symbol: "MAHSCOOTER" },
    { name: "Maharashtra Seamless Limited", symbol: "MAHSEAMLES" },
    { name: "Maithan Alloys Limited", symbol: "MAITHANALL" },
    { name: "Mallcom (India) Limited", symbol: "MALLCOM" },
    { name: "Malu Paper Mills Limited", symbol: "MALUPAPER" },
    { name: "Manaksia Aluminium Company Limited", symbol: "MANAKALUCO" },
    {
      name: "Manaksia Coated Metals & Industries Limited",
      symbol: "MANAKCOAT",
    },
    { name: "Manaksia Limited", symbol: "MANAKSIA" },
    { name: "Manaksia Steels Limited", symbol: "MANAKSTEEL" },
    { name: "Manali Petrochemicals Limited", symbol: "MANALIPETC" },
    { name: "Manappuram Finance Limited", symbol: "MANAPPURAM" },
    { name: "Mangalam Drugs And Organics Limited", symbol: "MANGALAM" },
    {
      name: "Mangalore Chemicals & Fertilizers Limited",
      symbol: "MANGCHEFER",
    },
    { name: "Mangalam Cement Limited", symbol: "MANGLMCEM" },
    { name: "Man Industries (India) Limited", symbol: "MANINDS" },
    { name: "Man Infraconstruction Limited", symbol: "MANINFRA" },
    { name: "Manomay Tex India Limited", symbol: "MANOMAY" },
    { name: "Manorama Industries Limited", symbol: "MANORAMA" },
    { name: "Mangalam Organics Limited", symbol: "MANORG" },
    { name: "Manugraph India Limited", symbol: "MANUGRAPH" },
    { name: "Vedant Fashions Limited", symbol: "MANYAVAR" },
    { name: "C.E. Info Systems Limited", symbol: "MAPMYINDIA" },
    { name: "Maral Overseas Limited", symbol: "MARALOVER" },
    { name: "Marathon Nextgen Realty Limited", symbol: "MARATHON" },
    { name: "Marico Limited", symbol: "MARICO" },
    { name: "Marine Electricals (India) Limited", symbol: "MARINE" },
    { name: "Marksans Pharma Limited", symbol: "MARKSANS" },
    { name: "Marshall Machines Limited", symbol: "MARSHALL" },
    { name: "Maruti Suzuki India Limited", symbol: "MARUTI" },
    { name: "MAS Financial Services Limited", symbol: "MASFIN" },
    { name: "Mask Investments Limited", symbol: "MASKINVEST" },
    { name: "Mastek Limited", symbol: "MASTEK" },
    { name: "Matrimony.Com Limited", symbol: "MATRIMONY" },
    { name: "Mawana Sugars Limited", symbol: "MAWANASUG" },
    { name: "Max Healthcare Institute Limited", symbol: "MAXHEALTH" },
    { name: "Max India Limited", symbol: "MAXIND" },
    { name: "Max Ventures and Industries Limited", symbol: "MAXVIL" },
    { name: "Mayur Uniquoters Ltd", symbol: "MAYURUNIQ" },
    { name: "Mazda Limited", symbol: "MAZDA" },
    { name: "Mazagon Dock Shipbuilders Limited", symbol: "MAZDOCK" },
    { name: "Madhya Bharat Agro Products Limited", symbol: "MBAPL" },
    { name: "Mcnally Bharat Engineering Company Limited", symbol: "MBECL" },
    { name: "MBL Infrastructure Limited", symbol: "MBLINFRA" },
    { name: "United Spirits Limited", symbol: "MCDOWELL-N" },
    { name: "Madhav Copper Limited", symbol: "MCL" },
    { name: "Mcleod Russel India Limited", symbol: "MCLEODRUSS" },
    { name: "Multi Commodity Exchange of India Limited", symbol: "MCX" },
    { name: "Global Health Limited", symbol: "MEDANTA" },
    { name: "Medicamen Biotech Limited", symbol: "MEDICAMEQ" },
    { name: "Medico Remedies Limited", symbol: "MEDICO" },
    { name: "Medplus Health Services Limited", symbol: "MEDPLUS" },
    { name: "Megasoft Limited", symbol: "MEGASOFT" },
    { name: "Megastar Foods Limited", symbol: "MEGASTAR" },
    { name: "Melstar Information Technologies Limited", symbol: "MELSTAR" },
    { name: "Menon Bearings Limited", symbol: "MENONBE" },
    { name: "MEP Infrastructure Developers Limited", symbol: "MEP" },
    { name: "Mercator Limited", symbol: "MERCATOR" },
    { name: "Metalyst Forgings Limited", symbol: "METALFORGE" },
    { name: "Metro Brands Limited", symbol: "METROBRAND" },
    { name: "Metropolis Healthcare Limited", symbol: "METROPOLIS" },
    { name: "Meghmani Finechem Limited", symbol: "MFL" },
    { name: "Max Financial Services Limited", symbol: "MFSL" },
    { name: "Mangalam Global Enterprise Limited", symbol: "MGEL" },
    { name: "Mahanagar Gas Limited", symbol: "MGL" },
    { name: "Mahalaxmi Rubtech Limited", symbol: "MHLXMIRU" },
    { name: "Mahindra Holidays & Resorts India Limited", symbol: "MHRIL" },
    { name: "Mishra Dhatu Nigam Limited", symbol: "MIDHANI" },
    { name: "Minda Corporation Limited", symbol: "MINDACORP" },
    { name: "Mindteck (India) Limited", symbol: "MINDTECK" },
    { name: "MIRC Electronics Limited", symbol: "MIRCELECTR" },
    { name: "Mirza International Limited", symbol: "MIRZAINT" },
    {
      name: "MITCON Consultancy & Engineering Services Limited",
      symbol: "MITCON",
    },
    { name: "Mittal Life Style Limited", symbol: "MITTAL" },
    { name: "MM Forgings Limited", symbol: "MMFL" },
    { name: "MMP Industries Limited", symbol: "MMP" },
    { name: "MMTC Limited", symbol: "MMTC" },
    { name: "Modi Rubber Limited", symbol: "MODIRUBBER" },
    { name: "MODISON LIMITED", symbol: "MODISONLTD" },
    { name: "Mohit Industries Limited", symbol: "MOHITIND" },
    { name: "MOIL Limited", symbol: "MOIL" },
    { name: "Moksh Ornaments Limited", symbol: "MOKSH" },
    { name: "Meghmani Organics Limited", symbol: "MOL" },
    { name: "Mold-Tek Technologies Limited", symbol: "MOLDTECH" },
    { name: "Mold-Tek Packaging Limited", symbol: "MOLDTKPAC" },
    { name: "Monarch Networth Capital Limited", symbol: "MONARCH" },
    { name: "Monte Carlo Fashions Limited", symbol: "MONTECARLO" },
    { name: "Morarjee Textiles Limited", symbol: "MORARJEE" },
    { name: "Morepen Laboratories Limited", symbol: "MOREPENLAB" },
    {
      name: "Samvardhana Motherson International Limited",
      symbol: "MOTHERSON",
    },
    {
      name: "Motilal Oswal Financial Services Limited",
      symbol: "MOTILALOFS",
    },
    { name: "The Motor & General Finance Limited", symbol: "MOTOGENFIN" },
    { name: "MphasiS Limited", symbol: "MPHASIS" },
    { name: "MPS Limited", symbol: "MPSLTD" },
    { name: "MRF Limited", symbol: "MRF" },
    { name: "MRO-TEK Realty Limited", symbol: "MRO-TEK" },
    { name: "Mangalore Refinery and Petrochemicals Limited", symbol: "MRPL" },
    { name: "MSP Steel & Power Limited", symbol: "MSPL" },
    { name: "Mstc Limited", symbol: "MSTCLTD" },
    { name: "Motherson Sumi Wiring India Limited", symbol: "MSUMI" },
    { name: "Mtar Technologies Limited", symbol: "MTARTECH" },
    { name: "MT Educare Limited", symbol: "MTEDUCARE" },
    { name: "Mahanagar Telephone Nigam Limited", symbol: "MTNL" },
    { name: "Mukand Limited", symbol: "MUKANDLTD" },
    { name: "Mukta Arts Limited", symbol: "MUKTAARTS" },
    { name: "Munjal Auto Industries Limited", symbol: "MUNJALAU" },
    { name: "Munjal Showa Limited", symbol: "MUNJALSHOW" },
    { name: "Murudeshwar Ceramics Limited", symbol: "MURUDCERA" },
    { name: "Muthoot Capital Services Limited", symbol: "MUTHOOTCAP" },
    { name: "Muthoot Finance Limited", symbol: "MUTHOOTFIN" },
    { name: "NACL Industries Limited", symbol: "NACLIND" },
    {
      name: "Nagarjuna Fertilizers and Chemicals Limited",
      symbol: "NAGAFERT",
    },
    {
      name: "Nagreeka Capital & Infrastructure Limited",
      symbol: "NAGREEKCAP",
    },
    { name: "Nagreeka Exports Limited", symbol: "NAGREEKEXP" },
    {
      name: "Nahar Capital and Financial Services Limited",
      symbol: "NAHARCAP",
    },
    { name: "Nahar Industrial Enterprises Limited", symbol: "NAHARINDUS" },
    { name: "Nahar Poly Films Limited", symbol: "NAHARPOLY" },
    { name: "Nahar Spinning Mills Limited", symbol: "NAHARSPING" },
    {
      name: "Nippon Life India Asset Management Limited",
      symbol: "NAM-INDIA",
    },
    { name: "Narmada Agrobase Limited", symbol: "NARMADA" },
    { name: "Natco Pharma Limited", symbol: "NATCOPHARM" },
    { name: "Nath Bio-Genes (India) Limited", symbol: "NATHBIOGEN" },
    { name: "National Aluminium Company Limited", symbol: "NATIONALUM" },
    {
      name: "National Steel And Agro Industries Limited",
      symbol: "NATNLSTEEL",
    },
    { name: "Info Edge (India) Limited", symbol: "NAUKRI" },
    { name: "NAVA LIMITED", symbol: "NAVA" },
    { name: "Navin Fluorine International Limited", symbol: "NAVINFLUOR" },
    { name: "Navkar Corporation Limited", symbol: "NAVKARCORP" },
    { name: "Navneet Education Limited", symbol: "NAVNETEDUL" },
    { name: "Nazara Technologies Limited", symbol: "NAZARA" },
    { name: "NBCC (India) Limited", symbol: "NBCC" },
    { name: "N. B. I. Industrial Finance Company Limited", symbol: "NBIFIN" },
    { name: "NCC Limited", symbol: "NCC" },
    { name: "NCL Industries Limited", symbol: "NCLIND" },
    { name: "Naga Dhunseri Group Limited", symbol: "NDGL" },
    { name: "Nandan Denim Limited", symbol: "NDL" },
    { name: "Ndr Auto Components Limited", symbol: "NDRAUTO" },
    { name: "New Delhi Television Limited", symbol: "NDTV" },
    { name: "North Eastern Carrying Corporation Limited", symbol: "NECCLTD" },
    { name: "Nectar Lifesciences Limited", symbol: "NECLIFE" },
    { name: "Nelcast Limited", symbol: "NELCAST" },
    { name: "NELCO Limited", symbol: "NELCO" },
    { name: "Neogen Chemicals Limited", symbol: "NEOGEN" },
    { name: "Nesco Limited", symbol: "NESCO" },
    { name: "Nestle India Limited", symbol: "NESTLEIND" },
    { name: "Network18 Media & Investments Limited", symbol: "NETWORK18" },
    { name: "Neuland Laboratories Limited", symbol: "NEULANDLAB" },
    { name: "Newgen Software Technologies Limited", symbol: "NEWGEN" },
    { name: "Next Mediaworks Limited", symbol: "NEXTMEDIA" },
    { name: "National Fertilizers Limited", symbol: "NFL" },
    { name: "Nakoda Group of Industries Limited", symbol: "NGIL" },
    { name: "NGL Fine-Chem Limited", symbol: "NGLFINE" },
    { name: "Narayana Hrudayalaya Ltd.", symbol: "NH" },
    { name: "NHPC Limited", symbol: "NHPC" },
    { name: "The New India Assurance Company Limited", symbol: "NIACL" },
    { name: "NRB Industrial Bearings Limited", symbol: "NIBL" },
    { name: "NIIT Limited", symbol: "NIITLTD" },
    { name: "Nila Infrastructures Limited", symbol: "NILAINFRA" },
    { name: "Nila Spaces Limited", symbol: "NILASPACES" },
    { name: "Nilkamal Limited", symbol: "NILKAMAL" },
    { name: "Indo-National Limited", symbol: "NIPPOBATRY" },
    { name: "Niraj Cement Structurals Limited", symbol: "NIRAJ" },
    { name: "Niraj Ispat Industries Limited", symbol: "NIRAJISPAT" },
    { name: "Nitco Limited", symbol: "NITCO" },
    { name: "Nitin Spinners Limited", symbol: "NITINSPIN" },
    { name: "Nitiraj Engineers Limited", symbol: "NITIRAJ" },
    { name: "NK Industries Limited", symbol: "NKIND" },
    { name: "NLC India Limited", symbol: "NLCINDIA" },
    { name: "NMDC Limited", symbol: "NMDC" },
    { name: "NOCIL Limited", symbol: "NOCIL" },
    { name: "Noida Toll Bridge Company Limited", symbol: "NOIDATOLL" },
    { name: "Norben Tea & Exports Limited", symbol: "NORBTEAEXP" },
    { name: "Novartis India Limited", symbol: "NOVARTIND" },
    { name: "N R Agarwal Industries Limited", symbol: "NRAIL" },
    { name: "NRB Bearing Limited", symbol: "NRBBEARING" },
    { name: "Nupur Recyclers Limited", symbol: "NRL" },
    { name: "Nalwa Sons Investments Limited", symbol: "NSIL" },
    { name: "NTPC Limited", symbol: "NTPC" },
    { name: "Nucleus Software Exports Limited", symbol: "NUCLEUS" },
    { name: "Nureca Limited", symbol: "NURECA" },
    { name: "Nuvoco Vistas Corporation Limited", symbol: "NUVOCO" },
    { name: "NXTDIGITAL LIMITED", symbol: "NXTDIGITAL" },
    { name: "FSN E-Commerce Ventures Limited", symbol: "NYKAA" },
    { name: "Oriental Aromatics Limited", symbol: "OAL" },
    { name: "Orissa Bengal Carrier Limited", symbol: "OBCL" },
    { name: "Oberoi Realty Limited", symbol: "OBEROIRLTY" },
    { name: "Oriental Carbon & Chemicals Limited", symbol: "OCCL" },
    { name: "Oracle Financial Services Software Limited", symbol: "OFSS" },
    { name: "Oil India Limited", symbol: "OIL" },
    { name: "Oil Country Tubular Limited", symbol: "OILCOUNTUB" },
    { name: "Olectra Greentech Limited", symbol: "OLECTRA" },
    { name: "Omax Autos Limited", symbol: "OMAXAUTO" },
    { name: "Omaxe Limited", symbol: "OMAXE" },
    { name: "OM INFRA LIMITED", symbol: "OMINFRAL" },
    { name: "Omkar Speciality Chemicals Limited", symbol: "OMKARCHEM" },
    { name: "Onelife Capital Advisors Limited", symbol: "ONELIFECAP" },
    { name: "One Point One Solutions Limited", symbol: "ONEPOINT" },
    { name: "Oil & Natural Gas Corporation Limited", symbol: "ONGC" },
    { name: "OnMobile Global Limited", symbol: "ONMOBILE" },
    { name: "Onward Technologies Limited", symbol: "ONWARDTEC" },
    { name: "Optiemus Infracom Limited", symbol: "OPTIEMUS" },
    { name: "Orbit Exports Limited", symbol: "ORBTEXP" },
    { name: "Orchid Pharma Limited", symbol: "ORCHPHARMA" },
    { name: "Oricon Enterprises Limited", symbol: "ORICONENT" },
    { name: "Orient Abrasives Limited", symbol: "ORIENTABRA" },
    { name: "Oriental Trimex Limited", symbol: "ORIENTALTL" },
    { name: "Orient Bell Limited", symbol: "ORIENTBELL" },
    { name: "Orient Cement Limited", symbol: "ORIENTCEM" },
    { name: "Orient Electric Limited", symbol: "ORIENTELEC" },
    { name: "Oriental Hotels Limited", symbol: "ORIENTHOT" },
    { name: "Orient Press Limited", symbol: "ORIENTLTD" },
    { name: "Orient Paper & Industries Limited", symbol: "ORIENTPPR" },
    {
      name: "The Orissa Minerals Development Company Limited",
      symbol: "ORISSAMINE",
    },
    { name: "Ortin Laboratories Limited", symbol: "ORTINLAB" },
    { name: "Osia Hyper Retail Limited", symbol: "OSIAHYPER" },
    { name: "Oswal Agro Mills Limited", symbol: "OSWALAGRO" },
    { name: "Page Industries Limited", symbol: "PAGEIND" },
    { name: "Paisalo Digital Limited", symbol: "PAISALO" },
    { name: "Palash Securities Limited", symbol: "PALASHSECU" },
    { name: "Palred Technologies Limited", symbol: "PALREDTEC" },
    { name: "Panacea Biotec Limited", symbol: "PANACEABIO" },
    { name: "Panache Digilife Limited", symbol: "PANACHE" },
    { name: "Panama Petrochem Limited", symbol: "PANAMAPET" },
    { name: "Pansari Developers Limited", symbol: "PANSARI" },
    { name: "Par Drugs And Chemicals Limited", symbol: "PAR" },
    { name: "Paramount Communications Limited", symbol: "PARACABLES" },
    { name: "Paradeep Phosphates Limited", symbol: "PARADEEP" },
    { name: "Parag Milk Foods Limited", symbol: "PARAGMILK" },
    { name: "Paras Defence and Space Technologies Limited", symbol: "PARAS" },
    { name: "Paras Petrofils Limited", symbol: "PARASPETRO" },
    { name: "Parsvnath Developers Limited", symbol: "PARSVNATH" },
    { name: "Pasupati Acrylon Limited", symbol: "PASUPTAC" },
    { name: "Patanjali Foods Limited", symbol: "PATANJALI" },
    { name: "Patel Engineering Limited", symbol: "PATELENG" },
    { name: "Patel Integrated Logistics Limited", symbol: "PATINTLOG" },
    { name: "One 97 Communications Limited", symbol: "PAYTM" },
    { name: "PCBL LIMITED", symbol: "PCBL" },
    { name: "PC Jeweller Limited", symbol: "PCJEWELLER" },
    { name: "Pudumjee Paper Products Limited", symbol: "PDMJEPAPER" },
    { name: "PDS Limited", symbol: "PDSL" },
    { name: "Pearl Polymers Limited", symbol: "PEARLPOLY" },
    { name: "Piramal Enterprises Limited", symbol: "PEL" },
    { name: "Pennar Industries Limited", symbol: "PENIND" },
    { name: "Peninsula Land Limited", symbol: "PENINLAND" },
    { name: "Persistent Systems Limited", symbol: "PERSISTENT" },
    { name: "Petronet LNG Limited", symbol: "PETRONET" },
    { name: "Power Finance Corporation Limited", symbol: "PFC" },
    { name: "Pfizer Limited", symbol: "PFIZER" },
    { name: "Prime Focus Limited", symbol: "PFOCUS" },
    { name: "PTC India Financial Services Limited", symbol: "PFS" },
    { name: "PG Electroplast Limited", symbol: "PGEL" },
    {
      name: "Procter & Gamble Hygiene and Health Care Limited",
      symbol: "PGHH",
    },
    { name: "Procter & Gamble Health Limited", symbol: "PGHL" },
    { name: "Pearl Global Industries Limited", symbol: "PGIL" },
    { name: "The Phoenix Mills Limited", symbol: "PHOENIXLTD" },
    { name: "Pidilite Industries Limited", symbol: "PIDILITIND" },
    { name: "PI Industries Limited", symbol: "PIIND" },
    {
      name: "Pilani Investment and Industries Corporation Limited",
      symbol: "PILANIINVS",
    },
    { name: "PIL ITALICA LIFESTYLE LIMITED", symbol: "PILITA" },
    { name: "Pioneer Embroideries Limited", symbol: "PIONEEREMB" },
    { name: "Pitti Engineering Limited", symbol: "PITTIENG" },
    { name: "Pix Transmissions Limited", symbol: "PIXTRANS" },
    {
      name: "The Peria Karamalai Tea & Produce Company Limited",
      symbol: "PKTEA",
    },
    { name: "Plastiblends India Limited", symbol: "PLASTIBLEN" },
    { name: "Punjab National Bank", symbol: "PNB" },
    { name: "PNB Gilts Limited", symbol: "PNBGILTS" },
    { name: "PNB Housing Finance Limited", symbol: "PNBHOUSING" },
    { name: "Pritish Nandy Communications Limited", symbol: "PNC" },
    { name: "PNC Infratech Limited", symbol: "PNCINFRA" },
    { name: "Poddar Housing and Development Limited", symbol: "PODDARHOUS" },
    { name: "Poddar Pigments Limited", symbol: "PODDARMENT" },
    { name: "Pokarna Limited", symbol: "POKARNA" },
    { name: "PB Fintech Limited", symbol: "POLICYBZR" },
    { name: "Polycab India Limited", symbol: "POLYCAB" },
    { name: "Poly Medicure Limited", symbol: "POLYMED" },
    { name: "Polyplex Corporation Limited", symbol: "POLYPLEX" },
    { name: "Ponni Sugars (Erode) Limited", symbol: "PONNIERODE" },
    { name: "Poonawalla Fincorp Limited", symbol: "POONAWALLA" },
    { name: "Power Grid Corporation of India Limited", symbol: "POWERGRID" },
    { name: "Hitachi Energy India Limited", symbol: "POWERINDIA" },
    { name: "Power Mech Projects Limited", symbol: "POWERMECH" },
    { name: "PPAP Automotive Limited", symbol: "PPAP" },
    { name: "Prakash Pipes Limited", symbol: "PPL" },
    { name: "Piramal Pharma Limited", symbol: "PPLPHARMA" },
    { name: "Prajay Engineers Syndicate Limited", symbol: "PRAENG" },
    { name: "Praj Industries Limited", symbol: "PRAJIND" },
    { name: "Prakash Industries Limited", symbol: "PRAKASH" },
    { name: "Prakash Steelage Limited", symbol: "PRAKASHSTL" },
    { name: "Praxis Home Retail Limited", symbol: "PRAXIS" },
    { name: "Precision Camshafts Limited", symbol: "PRECAM" },
    { name: "Precot Limited", symbol: "PRECOT" },
    { name: "Precision Wires India Limited", symbol: "PRECWIRE" },
    { name: "Premier Explosives Limited", symbol: "PREMEXPLN" },
    { name: "Premier Limited", symbol: "PREMIER" },
    { name: "Premier Polyfilm Limited", symbol: "PREMIERPOL" },
    { name: "Pressman Advertising Limited", symbol: "PRESSMN" },
    { name: "Prestige Estates Projects Limited", symbol: "PRESTIGE" },
    { name: "Pricol Limited", symbol: "PRICOLLTD" },
    { name: "Prime Securities Limited", symbol: "PRIMESECU" },
    { name: "Prince Pipes And Fittings Limited", symbol: "PRINCEPIPE" },
    { name: "Priti International Limited", symbol: "PRITI" },
    { name: "Pritika Auto Industries Limited", symbol: "PRITIKAUTO" },
    { name: "Privi Speciality Chemicals Limited", symbol: "PRIVISCL" },
    { name: "Prozone Intu Properties Limited", symbol: "PROZONINTU" },
    { name: "Prism Johnson Limited", symbol: "PRSMJOHNSN" },
    {
      name: "Prudent Corporate Advisory Services Limited",
      symbol: "PRUDENT",
    },
    { name: "Punjab & Sind Bank", symbol: "PSB" },
    { name: "PSP Projects Limited", symbol: "PSPPROJECT" },
    { name: "PTC India Limited", symbol: "PTC" },
    { name: "PTL Enterprises Limited", symbol: "PTL" },
    {
      name: "Punjab Chemicals & Crop Protection Limited",
      symbol: "PUNJABCHEM",
    },
    { name: "Puravankara Limited", symbol: "PURVA" },
    { name: "PVP Ventures Limited", symbol: "PVP" },
    { name: "PVR Limited", symbol: "PVR" },
    { name: "Quess Corp Limited", symbol: "QUESS" },
    { name: "Quick Heal Technologies Limited", symbol: "QUICKHEAL" },
    { name: "Radhika Jeweltech Limited", symbol: "RADHIKAJWE" },
    {
      name: "Radiant Cash Management Services Limited",
      symbol: "RADIANTCMS",
    },
    { name: "Radico Khaitan Limited", symbol: "RADICO" },
    { name: "Music Broadcast Limited", symbol: "RADIOCITY" },
    { name: "Railtel Corporation Of India Limited", symbol: "RAILTEL" },
    { name: "Rain Industries Limited", symbol: "RAIN" },
    { name: "Rainbow Childrens Medicare Limited", symbol: "RAINBOW" },
    { name: "Rajesh Exports Limited", symbol: "RAJESHEXPO" },
    { name: "Rajnandini Metal Limited", symbol: "RAJMET" },
    { name: "Rajratan Global Wire Limited", symbol: "RAJRATAN" },
    { name: "Raj Rayon Industries Limited", symbol: "RAJRILTD" },
    { name: "Rajshree Sugars & Chemicals Limited", symbol: "RAJSREESUG" },
    { name: "Raj Television Network Limited", symbol: "RAJTV" },
    { name: "Rallis India Limited", symbol: "RALLIS" },
    { name: "Shree Rama Newsprint Limited", symbol: "RAMANEWS" },
    { name: "Rama Phosphates Limited", symbol: "RAMAPHO" },
    { name: "Rama Steel Tubes Limited", symbol: "RAMASTEEL" },
    { name: "The Ramco Cements Limited", symbol: "RAMCOCEM" },
    { name: "Ramco Industries Limited", symbol: "RAMCOIND" },
    { name: "Ramco Systems Limited", symbol: "RAMCOSYS" },
    { name: "Ramky Infrastructure Limited", symbol: "RAMKY" },
    { name: "Ram Ratna Wires Limited", symbol: "RAMRAT" },
    { name: "Rana Sugars Limited", symbol: "RANASUG" },
    { name: "Rane Engine Valve Limited", symbol: "RANEENGINE" },
    { name: "Rane Holdings Limited", symbol: "RANEHOLDIN" },
    { name: "Rategain Travel Technologies Limited", symbol: "RATEGAIN" },
    { name: "Ratnamani Metals & Tubes Limited", symbol: "RATNAMANI" },
    { name: "Raymond Limited", symbol: "RAYMOND" },
    { name: "Restaurant Brands Asia Limited", symbol: "RBA" },
    { name: "Rane Brake Lining Limited", symbol: "RBL" },
    { name: "RBL Bank Limited", symbol: "RBLBANK" },
    { name: "Rashtriya Chemicals and Fertilizers Limited", symbol: "RCF" },
    { name: "Reliance Communications Limited", symbol: "RCOM" },
    { name: "REC Limited", symbol: "RECLTD" },
    { name: "Redington Limited", symbol: "REDINGTON" },
    { name: "Refex Industries Limited", symbol: "REFEX" },
    { name: "Regency Ceramics Limited", symbol: "REGENCERAM" },
    { name: "Relaxo Footwears Limited", symbol: "RELAXO" },
    { name: "Reliance Chemotex Industries Limited", symbol: "RELCHEMQ" },
    { name: "Reliance Industries Limited", symbol: "RELIANCE" },
    { name: "Religare Enterprises Limited", symbol: "RELIGARE" },
    { name: "Reliance Infrastructure Limited", symbol: "RELINFRA" },
    { name: "Remsons Industries Limited", symbol: "REMSONSIND" },
    { name: "Shree Renuka Sugars Limited", symbol: "RENUKA" },
    { name: "Repco Home Finance Limited", symbol: "REPCOHOME" },
    { name: "Rudrabhishek Enterprises Limited", symbol: "REPL" },
    { name: "Repro India Limited", symbol: "REPRO" },
    { name: "Responsive Industries Limited", symbol: "RESPONIND" },
    { name: "Revathi Equipment Limited", symbol: "REVATHI" },
    { name: "Renaissance Global Limited", symbol: "RGL" },
    { name: "Reliance Home Finance Limited", symbol: "RHFL" },
    { name: "RHI MAGNESITA INDIA LIMITED", symbol: "RHIM" },
    { name: "Rico Auto Industries Limited", symbol: "RICOAUTO" },
    { name: "Reliance Industrial Infrastructure Limited", symbol: "RIIL" },
    { name: "Ritco Logistics Limited", symbol: "RITCO" },
    { name: "RITES Limited", symbol: "RITES" },
    { name: "Ravi Kumar Distilleries Limited", symbol: "RKDL" },
    { name: "RKEC Projects Limited", symbol: "RKEC" },
    { name: "Ramkrishna Forgings Limited", symbol: "RKFORGE" },
    { name: "Radha Madhav Corporation Limited", symbol: "RMCL" },
    { name: "Rane (Madras) Limited", symbol: "RML" },
    { name: "Reliance Naval and Engineering Limited", symbol: "RNAVAL" },
    { name: "Royal Orchid Hotels Limited", symbol: "ROHLTD" },
    { name: "Rolex Rings Limited", symbol: "ROLEXRINGS" },
    { name: "Rollatainers Limited", symbol: "ROLLT" },
    { name: "Rolta India Limited", symbol: "ROLTA" },
    { name: "Raj Oil Mills Limited", symbol: "ROML" },
    { name: "Rossari Biotech Limited", symbol: "ROSSARI" },
    { name: "Rossell India Limited", symbol: "ROSSELLIND" },
    { name: "Roto Pumps Limited", symbol: "ROTO" },
    { name: "ROUTE MOBILE LIMITED", symbol: "ROUTE" },
    { name: "RPG Life Sciences Limited", symbol: "RPGLIFE" },
    { name: "Reliance Power Limited", symbol: "RPOWER" },
    { name: "R.P.P. Infra Projects Limited", symbol: "RPPINFRA" },
    { name: "Rajshree Polypack Limited", symbol: "RPPL" },
    { name: "RPSG VENTURES LIMITED", symbol: "RPSGVENT" },
    { name: "R. S. Software (India) Limited", symbol: "RSSOFTWARE" },
    { name: "RSWM Limited", symbol: "RSWM" },
    { name: "R Systems International Limited", symbol: "RSYSTEMS" },
    { name: "RattanIndia Enterprises Limited", symbol: "RTNINDIA" },
    { name: "RattanIndia Power Limited", symbol: "RTNPOWER" },
    { name: "The Ruby Mills Limited", symbol: "RUBYMILLS" },
    { name: "Ruchi Infrastructure Limited", symbol: "RUCHINFRA" },
    { name: "Ruchira Papers Limited", symbol: "RUCHIRA" },
    { name: "Rupa & Company Limited", symbol: "RUPA" },
    { name: "Rushil Decor Limited", symbol: "RUSHIL" },
    { name: "Keystone Realtors Limited", symbol: "RUSTOMJEE" },
    { name: "Ravinder Heights Limited", symbol: "RVHL" },
    { name: "Rail Vikas Nigam Limited", symbol: "RVNL" },
    { name: "S&S Power Switchgears Limited", symbol: "S&SPOWER" },
    {
      name: "Sab Events & Governance Now Media Limited",
      symbol: "SABEVENTS",
    },
    { name: "Sadbhav Engineering Limited", symbol: "SADBHAV" },
    { name: "Sadbhav Infrastructure Project Limited", symbol: "SADBHIN" },
    { name: "Safari Industries (India) Limited", symbol: "SAFARI" },
    { name: "Sagardeep Alloys Limited", symbol: "SAGARDEEP" },
    { name: "Sagar Cements Limited", symbol: "SAGCEM" },
    { name: "Sah Polymers Limited", symbol: "SAH" },
    { name: "Steel Authority of India Limited", symbol: "SAIL" },
    { name: "Sakar Healthcare Limited", symbol: "SAKAR" },
    { name: "Sakthi Sugars Limited", symbol: "SAKHTISUG" },
    { name: "Saksoft Limited", symbol: "SAKSOFT" },
    { name: "Sakuma Exports Limited", symbol: "SAKUMA" },
    { name: "Salasar Techno Engineering Limited", symbol: "SALASAR" },
    { name: "Salona Cotspin Limited", symbol: "SALONA" },
    { name: "S.A.L. Steel Limited", symbol: "SALSTEEL" },
    { name: "Salzer Electronics Limited", symbol: "SALZERELEC" },
    { name: "Sambhaav Media Limited", symbol: "SAMBHAAV" },
    { name: "The Sandesh Limited", symbol: "SANDESH" },
    { name: "Sandhar Technologies Limited", symbol: "SANDHAR" },
    { name: "Sangam (India) Limited", symbol: "SANGAMIND" },
    { name: "Sanghi Industries Limited", symbol: "SANGHIIND" },
    { name: "Sanghvi Movers Limited", symbol: "SANGHVIMOV" },
    { name: "Sanginita Chemicals Limited", symbol: "SANGINITA" },
    { name: "Sanofi India Limited", symbol: "SANOFI" },
    { name: "Sansera Engineering Limited", symbol: "SANSERA" },
    { name: "Sanwaria Consumer Limited", symbol: "SANWARIA" },
    { name: "Sapphire Foods India Limited", symbol: "SAPPHIRE" },
    { name: "Sarda Energy & Minerals Limited", symbol: "SARDAEN" },
    { name: "Saregama India Limited", symbol: "SAREGAMA" },
    { name: "Sarla Performance Fibers Limited", symbol: "SARLAPOLY" },
    { name: "Sarveshwar Foods Limited", symbol: "SARVESHWAR" },
    { name: "Sasken Technologies Limited", symbol: "SASKEN" },
    { name: "Sastasundar Ventures Limited", symbol: "SASTASUNDR" },
    { name: "Sathavahana Ispat Limited", symbol: "SATHAISPAT" },
    { name: "Satia Industries Limited", symbol: "SATIA" },
    { name: "Satin Creditcare Network Limited", symbol: "SATIN" },
    { name: "Sat Industries Limited", symbol: "SATINDLTD" },
    { name: "SBC Exports Limited", symbol: "SBC" },
    { name: "Shivalik Bimetal Controls Limited", symbol: "SBCL" },
    { name: "SBI Cards and Payment Services Limited", symbol: "SBICARD" },
    { name: "SBI Life Insurance Company Limited", symbol: "SBILIFE" },
    { name: "State Bank of India", symbol: "SBIN" },
    { name: "Stampede Capital Limited", symbol: "SCAPDVR" },
    { name: "Schaeffler India Limited", symbol: "SCHAEFFLER" },
    { name: "S Chand And Company Limited", symbol: "SCHAND" },
    {
      name: "Schneider Electric Infrastructure Limited",
      symbol: "SCHNEIDER",
    },
    { name: "Shipping Corporation Of India Limited", symbol: "SCI" },
    { name: "Sheetal Cool Products Limited", symbol: "SCPL" },
    { name: "Som Distilleries & Breweries Limited", symbol: "SDBL" },
    { name: "Seamec Limited", symbol: "SEAMECLTD" },
    { name: "SecUR Credentials Limited", symbol: "SECURCRED" },
    { name: "SECUREKLOUD TECHNOLOGIES LIMITED", symbol: "SECURKLOUD" },
    { name: "Sejal Glass Limited", symbol: "SEJALLTD" },
    { name: "Selan Exploration Technology Limited", symbol: "SELAN" },
    { name: "SEPC Limited", symbol: "SEPC" },
    { name: "S.E. Power Limited", symbol: "SEPOWER" },
    { name: "Sequent Scientific Limited", symbol: "SEQUENT" },
    { name: "Servotech Power Systems Limited", symbol: "SERVOTECH" },
    { name: "Seshasayee Paper and Boards Limited", symbol: "SESHAPAPER" },
    { name: "Setco Automotive Limited", symbol: "SETCO" },
    { name: "Setubandhan Infrastructure Limited", symbol: "SETUINFRA" },
    { name: "Sheela Foam Limited", symbol: "SFL" },
    { name: "Synergy Green Industries Limited", symbol: "SGIL" },
    { name: "STL Global Limited", symbol: "SGL" },
    { name: "Shah Alloys Limited", symbol: "SHAHALLOYS" },
    { name: "Shaily Engineering Plastics Limited", symbol: "SHAILY" },
    { name: "Shakti Pumps (India) Limited", symbol: "SHAKTIPUMP" },
    { name: "Shalby Limited", symbol: "SHALBY" },
    { name: "Shalimar Paints Limited", symbol: "SHALPAINTS" },
    { name: "Shankara Building Products Limited", symbol: "SHANKARA" },
    { name: "Shanti Overseas (India) Limited", symbol: "SHANTI" },
    { name: "Shanthi Gears Limited", symbol: "SHANTIGEAR" },
    { name: "Sharda Cropchem Limited", symbol: "SHARDACROP" },
    { name: "Sharda Motor Industries Limited", symbol: "SHARDAMOTR" },
    { name: "Share India Securities Limited", symbol: "SHAREINDIA" },
    { name: "Shemaroo Entertainment Limited", symbol: "SHEMAROO" },
    { name: "Shilpa Medicare Limited", symbol: "SHILPAMED" },
    { name: "Shivalik Rasayan Limited", symbol: "SHIVALIK" },
    { name: "Shivam Autotech Limited", symbol: "SHIVAMAUTO" },
    { name: "Shiva Mills Limited", symbol: "SHIVAMILLS" },
    { name: "Shiva Texyarn Limited", symbol: "SHIVATEX" },
    { name: "S H Kelkar and Company Limited", symbol: "SHK" },
    { name: "Shoppers Stop Limited", symbol: "SHOPERSTOP" },
    { name: "Shradha Infraprojects Limited", symbol: "SHRADHA" },
    { name: "Shree Digvijay Cement Co.Ltd", symbol: "SHREDIGCEM" },
    { name: "SHREE CEMENT LIMITED", symbol: "SHREECEM" },
    {
      name: "Shree Pushkar Chemicals & Fertilisers Limited",
      symbol: "SHREEPUSHK",
    },
    { name: "Shree Rama Multi-Tech Limited", symbol: "SHREERAMA" },
    { name: "Shrenik Limited", symbol: "SHRENIK" },
    { name: "Shreyans Industries Limited", symbol: "SHREYANIND" },
    { name: "Shreyas Shipping & Logistics Limited", symbol: "SHREYAS" },
    { name: "Shriram Pistons & Rings Limited", symbol: "SHRIPISTON" },
    { name: "Shriram Finance Limited", symbol: "SHRIRAMFIN" },
    { name: "Shriram Properties Limited", symbol: "SHRIRAMPPS" },
    { name: "Shyam Century Ferrous Limited", symbol: "SHYAMCENT" },
    { name: "Shyam Metalics and Energy Limited", symbol: "SHYAMMETL" },
    { name: "Shyam Telecom Limited", symbol: "SHYAMTEL" },
    { name: "Siemens Limited", symbol: "SIEMENS" },
    { name: "Sigachi Industries Limited", symbol: "SIGACHI" },
    { name: "Signet Industries Limited", symbol: "SIGIND" },
    { name: "Sikko Industries Limited", symbol: "SIKKO" },
    { name: "Standard Industries Limited", symbol: "SIL" },
    { name: "Silgo Retail Limited", symbol: "SILGO" },
    { name: "SIL Investments Limited", symbol: "SILINV" },
    { name: "Silly Monks Entertainment Limited", symbol: "SILLYMONKS" },
    { name: "Silver Touch Technologies Limited", symbol: "SILVERTUC" },
    { name: "Simbhaoli Sugars Limited", symbol: "SIMBHALS" },
    { name: "Simplex Infrastructures Limited", symbol: "SIMPLEXINF" },
    { name: "Sintercom India Limited", symbol: "SINTERCOM" },
    { name: "Sintex Industries Limited", symbol: "SINTEX" },
    { name: "Sirca Paints India Limited", symbol: "SIRCA" },
    { name: "SIS LIMITED", symbol: "SIS" },
    { name: "Siti Networks Limited", symbol: "SITINET" },
    { name: "Siyaram Silk Mills Limited", symbol: "SIYSIL" },
    { name: "S.J.S. Enterprises Limited", symbol: "SJS" },
    { name: "SJVN Limited", symbol: "SJVN" },
    { name: "SKF India Limited", symbol: "SKFINDIA" },
    { name: "Skipper Limited", symbol: "SKIPPER" },
    { name: "SKM Egg Products Export (India) Limited", symbol: "SKMEGGPROD" },
    { name: "Sky Gold Limited", symbol: "SKYGOLD" },
    { name: "Smartlink Holdings Limited", symbol: "SMARTLINK" },
    { name: "SMC Global Securities Limited", symbol: "SMCGLOBAL" },
    { name: "SML Isuzu Limited", symbol: "SMLISUZU" },
    { name: "Sarthak Metals Limited", symbol: "SMLT" },
    { name: "SMS Lifesciences India Limited", symbol: "SMSLIFE" },
    { name: "SMS Pharmaceuticals Limited", symbol: "SMSPHARMA" },
    { name: "Snowman Logistics Limited", symbol: "SNOWMAN" },
    { name: "Sobha Limited", symbol: "SOBHA" },
    { name: "Softtech Engineers Limited", symbol: "SOFTTECH" },
    { name: "Solara Active Pharma Sciences Limited", symbol: "SOLARA" },
    { name: "Solar Industries India Limited", symbol: "SOLARINDS" },
    { name: "Somany Ceramics Limited", symbol: "SOMANYCERA" },
    { name: "Soma Textiles & Industries Limited", symbol: "SOMATEX" },
    { name: "Somi Conveyor Beltings Limited", symbol: "SOMICONVEY" },
    { name: "Sona BLW Precision Forgings Limited", symbol: "SONACOMS" },
    { name: "Sonam Clock Limited", symbol: "SONAMCLOCK" },
    { name: "Sonata Software Limited", symbol: "SONATSOFTW" },
    { name: "Savita Oil Technologies Limited", symbol: "SOTL" },
    { name: "The South Indian Bank Limited", symbol: "SOUTHBANK" },
    { name: "South West Pinnacle Exploration Limited", symbol: "SOUTHWEST" },
    { name: "S. P. Apparels Limited", symbol: "SPAL" },
    { name: "Spandana Sphoorty Financial Limited", symbol: "SPANDANA" },
    { name: "Sun Pharma Advanced Research Company Limited", symbol: "SPARC" },
    { name: "Spacenet Enterprises India Limited", symbol: "SPCENET" },
    { name: "Speciality Restaurants Limited", symbol: "SPECIALITY" },
    { name: "Spencer's Retail Limited", symbol: "SPENCERS" },
    {
      name: "Southern Petrochemicals Industries Corporation  Limited",
      symbol: "SPIC",
    },
    { name: "SPICEJET LTD", symbol: "SPICEJET" },
    { name: "SPL Industries Limited", symbol: "SPLIL" },
    { name: "Supreme Petrochem Limited", symbol: "SPLPETRO" },
    { name: "SPML Infra Limited", symbol: "SPMLINFRA" },
    { name: "Sportking India Limited", symbol: "SPORTKING" },
    { name: "Sintex Plastics Technology Limited", symbol: "SPTL" },
    { name: "Sreeleathers Limited", symbol: "SREEL" },
    { name: "SRF Limited", symbol: "SRF" },
    {
      name: "Sree Rayalaseema Hi-Strength Hypo Limited",
      symbol: "SRHHYPOLTD",
    },
    { name: "Shree Ram Proteins Limited", symbol: "SRPL" },
    { name: "Steel Strips Wheels Limited", symbol: "SSWL" },
    { name: "Strides Pharma Science Limited", symbol: "STAR" },
    { name: "Star Cement Limited", symbol: "STARCEMENT" },
    {
      name: "Star Health and Allied Insurance Company Limited",
      symbol: "STARHEALTH",
    },
    { name: "Star Paper Mills Limited", symbol: "STARPAPER" },
    { name: "Starteck Finance Limited", symbol: "STARTECK" },
    {
      name: "The State Trading Corporation of India Limited",
      symbol: "STCINDIA",
    },
    { name: "Steelcast Limited", symbol: "STEELCAS" },
    { name: "Steel City Securities Limited", symbol: "STEELCITY" },
    { name: "STEEL EXCHANGE INDIA LIMITED", symbol: "STEELXIND" },
    { name: "Stel Holdings Limited", symbol: "STEL" },
    { name: "Sterling Tools Limited", symbol: "STERTOOLS" },
    { name: "Sterlite Technologies Limited", symbol: "STLTECH" },
    { name: "Stove Kraft Limited", symbol: "STOVEKRAFT" },
    { name: "Stylam Industries Limited", symbol: "STYLAMIND" },
    { name: "Styrenix Performance Materials Limited", symbol: "STYRENIX" },
    { name: "Subex Limited", symbol: "SUBEXLTD" },
    { name: "Subros Limited", symbol: "SUBROS" },
    { name: "Sudarshan Chemical Industries Limited", symbol: "SUDARSCHEM" },
    { name: "Sukhjit Starch & Chemicals Limited", symbol: "SUKHJITS" },
    { name: "Sula Vineyards Limited", symbol: "SULA" },
    { name: "Sumeet Industries Limited", symbol: "SUMEETINDS" },
    { name: "Sumitomo Chemical India Limited", symbol: "SUMICHEM" },
    { name: "Sumit Woods Limited", symbol: "SUMIT" },
    { name: "Summit Securities Limited", symbol: "SUMMITSEC" },
    { name: "Sundaram Clayton Limited", symbol: "SUNCLAYLTD" },
    { name: "Sundaram Multi Pap Limited", symbol: "SUNDARAM" },
    { name: "Sundaram Finance Limited", symbol: "SUNDARMFIN" },
    { name: "Sundaram Finance Holdings Limited", symbol: "SUNDARMHLD" },
    { name: "Sundaram Brake Linings Limited", symbol: "SUNDRMBRAK" },
    { name: "Sundram Fasteners Limited", symbol: "SUNDRMFAST" },
    { name: "Sunflag Iron And Steel Company Limited", symbol: "SUNFLAG" },
    { name: "Sun Pharmaceutical Industries Limited", symbol: "SUNPHARMA" },
    { name: "Sunteck Realty Limited", symbol: "SUNTECK" },
    { name: "Sun TV Network Limited", symbol: "SUNTV" },
    { name: "Superhouse Limited", symbol: "SUPERHOUSE" },
    { name: "Super Spinning Mills Limited", symbol: "SUPERSPIN" },
    { name: "Suprajit Engineering Limited", symbol: "SUPRAJIT" },
    { name: "Supreme Engineering Limited", symbol: "SUPREMEENG" },
    { name: "Supreme Industries Limited", symbol: "SUPREMEIND" },
    { name: "Supreme Infrastructure India Limited", symbol: "SUPREMEINF" },
    { name: "Supriya Lifescience Limited", symbol: "SUPRIYA" },
    { name: "Surana Solar Limited", symbol: "SURANASOL" },
    { name: "Surana Telecom and Power Limited", symbol: "SURANAT&P" },
    { name: "Suryalakshmi Cotton Mills Limited", symbol: "SURYALAXMI" },
    { name: "Surya Roshni Limited", symbol: "SURYAROSNI" },
    { name: "Suryoday Small Finance Bank Limited", symbol: "SURYODAY" },
    { name: "Sutlej Textiles and Industries Limited", symbol: "SUTLEJTEX" },
    { name: "Suumaya Industries Limited", symbol: "SUULD" },
    { name: "Suven Life Sciences Limited", symbol: "SUVEN" },
    { name: "Suven Pharmaceuticals Limited", symbol: "SUVENPHAR" },
    { name: "Suvidhaa Infoserve Limited", symbol: "SUVIDHAA" },
    { name: "Suzlon Energy Limited", symbol: "SUZLON" },
    { name: "SVP GLOBAL TEXTILES LIMITED", symbol: "SVPGLOB" },
    { name: "Swan Energy Limited", symbol: "SWANENERGY" },
    { name: "Swaraj Engines Limited", symbol: "SWARAJENG" },
    { name: "Swelect Energy Systems Limited", symbol: "SWELECTES" },
    {
      name: "Sterling and Wilson Renewable Energy Limited",
      symbol: "SWSOLAR",
    },
    { name: "Symphony Limited", symbol: "SYMPHONY" },
    { name: "Syncom Formulations (India) Limited", symbol: "SYNCOMF" },
    { name: "Syngene International Limited", symbol: "SYNGENE" },
    { name: "Syrma SGS Technology Limited", symbol: "SYRMA" },
    {
      name: "Tainwala Chemical and Plastic (I) Limited",
      symbol: "TAINWALCHM",
    },
    { name: "Taj GVK Hotels & Resorts Limited", symbol: "TAJGVK" },
    { name: "Take Solutions Limited", symbol: "TAKE" },
    { name: "Talbros Automotive Components Limited", symbol: "TALBROAUTO" },
    { name: "Tanla Platforms Limited", symbol: "TANLA" },
    { name: "Tantia Constructions Limited", symbol: "TANTIACONS" },
    { name: "Tarapur Transformers Limited", symbol: "TARAPUR" },
    { name: "TARC Limited", symbol: "TARC" },
    { name: "Tarmat Limited", symbol: "TARMAT" },
    { name: "Tarsons Products Limited", symbol: "TARSONS" },
    { name: "Tasty Bite Eatables Limited", symbol: "TASTYBITE" },
    { name: "Tata Chemicals Limited", symbol: "TATACHEM" },
    { name: "Tata Coffee Limited", symbol: "TATACOFFEE" },
    { name: "Tata Communications Limited", symbol: "TATACOMM" },
    { name: "TATA CONSUMER PRODUCTS LIMITED", symbol: "TATACONSUM" },
    { name: "Tata Elxsi Limited", symbol: "TATAELXSI" },
    { name: "Tata Investment Corporation Limited", symbol: "TATAINVEST" },
    { name: "Tata Metaliks Limited", symbol: "TATAMETALI" },
    { name: "Tata Motors Limited", symbol: "TATAMOTORS" },
    { name: "Tata Motors Limited", symbol: "TATAMTRDVR" },
    { name: "Tata Power Company Limited", symbol: "TATAPOWER" },
    { name: "Tata Steel Limited", symbol: "TATASTEEL" },
    { name: "Tata Steel Long Products Limited", symbol: "TATASTLLP" },
    { name: "Tatva Chintan Pharma Chem Limited", symbol: "TATVA" },
    { name: "Tribhovandas Bhimji Zaveri Limited", symbol: "TBZ" },
    { name: "Transport Corporation of India Limited", symbol: "TCI" },
    { name: "TCI Express Limited", symbol: "TCIEXP" },
    { name: "TCNS Clothing Co. Limited", symbol: "TCNSBRANDS" },
    { name: "TCPL Packaging Limited", symbol: "TCPLPACK" },
    { name: "Tata Consultancy Services Limited", symbol: "TCS" },
    { name: "TD Power Systems Limited", symbol: "TDPOWERSYS" },
    { name: "Teamlease Services Limited", symbol: "TEAMLEASE" },
    { name: "Techindia Nirman Limited", symbol: "TECHIN" },
    { name: "Tech Mahindra Limited", symbol: "TECHM" },
    {
      name: "Techno Electric & Engineering Company Limited",
      symbol: "TECHNOE",
    },
    { name: "Tega Industries Limited", symbol: "TEGA" },
    { name: "Tejas Networks Limited", symbol: "TEJASNET" },
    { name: "Tembo Global Industries Limited", symbol: "TEMBO" },
    { name: "Tera Software Limited", symbol: "TERASOFT" },
    { name: "Texmaco Infrastructure & Holdings Limited", symbol: "TEXINFRA" },
    { name: "Texmo Pipes and Products Limited", symbol: "TEXMOPIPES" },
    { name: "Texmaco Rail & Engineering Limited", symbol: "TEXRAIL" },
    {
      name: "Tourism Finance Corporation of India Limited",
      symbol: "TFCILTD",
    },
    { name: "Transwarranty Finance Limited", symbol: "TFL" },
    { name: "TGB Banquets And Hotels Limited", symbol: "TGBHOTELS" },
    { name: "Thangamayil Jewellery Limited", symbol: "THANGAMAYL" },
    { name: "The Investment Trust Of India Limited", symbol: "THEINVEST" },
    { name: "Themis Medicare Limited", symbol: "THEMISMED" },
    { name: "Thermax Limited", symbol: "THERMAX" },
    { name: "Thomas Cook  (India)  Limited", symbol: "THOMASCOOK" },
    { name: "Thomas Scott (India) Limited", symbol: "THOMASCOTT" },
    { name: "Thyrocare Technologies Limited", symbol: "THYROCARE" },
    { name: "Tilaknagar Industries Limited", symbol: "TI" },
    { name: "Tide Water Oil Company (India) Limited", symbol: "TIDEWATER" },
    { name: "Technocraft Industries (India) Limited", symbol: "TIIL" },
    { name: "Tube Investments of India Limited", symbol: "TIINDIA" },
    { name: "Tijaria Polypipes Limited", symbol: "TIJARIA" },
    { name: "TIL Limited", symbol: "TIL" },
    { name: "Times Guaranty Limited", symbol: "TIMESGTY" },
    { name: "Time Technoplast Limited", symbol: "TIMETECHNO" },
    { name: "Timken India Limited", symbol: "TIMKEN" },
    { name: "The Tinplate Company of India Limited", symbol: "TINPLATE" },
    { name: "Tips Films Limited", symbol: "TIPSFILMS" },
    { name: "TIPS Industries Limited", symbol: "TIPSINDLTD" },
    { name: "Thirumalai Chemicals Limited", symbol: "TIRUMALCHM" },
    { name: "Tirupati Forge Limited", symbol: "TIRUPATIFL" },
    { name: "Titan Company Limited", symbol: "TITAN" },
    { name: "Tamilnad Mercantile Bank Limited", symbol: "TMB" },
    { name: "Tamilnadu PetroProducts Limited", symbol: "TNPETRO" },
    { name: "Tamil Nadu Newsprint & Papers Limited", symbol: "TNPL" },
    { name: "Tamilnadu Telecommunication Limited", symbol: "TNTELE" },
    { name: "Tokyo Plast International Limited", symbol: "TOKYOPLAST" },
    { name: "Torrent Pharmaceuticals Limited", symbol: "TORNTPHARM" },
    { name: "Torrent Power Limited", symbol: "TORNTPOWER" },
    { name: "Total Transport Systems Limited", symbol: "TOTAL" },
    { name: "Touchwood Entertainment Limited", symbol: "TOUCHWOOD" },
    { name: "TPL Plastech Limited", symbol: "TPLPLASTEH" },
    { name: "Tracxn Technologies Limited", symbol: "TRACXN" },
    {
      name: "Tree House Education & Accessories Limited",
      symbol: "TREEHOUSE",
    },
    { name: "TREJHARA SOLUTIONS LIMITED", symbol: "TREJHARA" },
    { name: "Trent Limited", symbol: "TRENT" },
    { name: "TRF Limited", symbol: "TRF" },
    { name: "Trident Limited", symbol: "TRIDENT" },
    { name: "Trigyn Technologies Limited", symbol: "TRIGYN" },
    { name: "Transformers And Rectifiers (India) Limited", symbol: "TRIL" },
    { name: "Triveni Turbine Limited", symbol: "TRITURBINE" },
    { name: "Triveni Engineering & Industries Limited", symbol: "TRIVENI" },
    { name: "TruCap Finance Limited", symbol: "TRU" },
    { name: "TTK Healthcare Limited", symbol: "TTKHLTCARE" },
    { name: "TTK Prestige Limited", symbol: "TTKPRESTIG" },
    { name: "T T Limited", symbol: "TTL" },
    { name: "Tata Teleservices (Maharashtra) Limited", symbol: "TTML" },
    { name: "TV18 Broadcast Limited", symbol: "TV18BRDCST" },
    { name: "TVS Electronics Limited", symbol: "TVSELECT" },
    { name: "TVS Motor Company Limited", symbol: "TVSMOTOR" },
    { name: "TVS Srichakra Limited", symbol: "TVSSRICHAK" },
    { name: "TV Today Network Limited", symbol: "TVTODAY" },
    { name: "TV Vision Limited", symbol: "TVVISION" },
    { name: "Titagarh Wagons Limited", symbol: "TWL" },
    { name: "United Breweries Limited", symbol: "UBL" },
    { name: "Ucal Fuel Systems Limited", symbol: "UCALFUEL" },
    { name: "UCO Bank", symbol: "UCOBANK" },
    { name: "Udaipur Cement Works Limited", symbol: "UDAICEMENT" },
    { name: "UFLEX Limited", symbol: "UFLEX" },
    { name: "UFO Moviez India Limited", symbol: "UFO" },
    { name: "The Ugar Sugar Works Limited", symbol: "UGARSUGAR" },
    { name: "Ugro Capital Limited", symbol: "UGROCAP" },
    { name: "Ujaas Energy Limited", symbol: "UJAAS" },
    { name: "Ujjivan Financial Services Limited", symbol: "UJJIVAN" },
    { name: "Ujjivan Small Finance Bank Limited", symbol: "UJJIVANSFB" },
    { name: "UltraTech Cement Limited", symbol: "ULTRACEMCO" },
    { name: "Uma Exports Limited", symbol: "UMAEXPORTS" },
    { name: "Umang Dairies Limited", symbol: "UMANGDAIRY" },
    { name: "Usha Martin Education & Solutions Limited", symbol: "UMESLTD" },
    { name: "Unichem Laboratories Limited", symbol: "UNICHEMLAB" },
    { name: "United Drilling Tools Limited", symbol: "UNIDT" },
    { name: "Uniphos Enterprises Limited", symbol: "UNIENTER" },
    { name: "Uniinfo Telecom Services Limited", symbol: "UNIINFO" },
    { name: "Union Bank of India", symbol: "UNIONBANK" },
    { name: "Uniparts India Limited", symbol: "UNIPARTS" },
    { name: "Unitech Limited", symbol: "UNITECH" },
    { name: "United Polyfab Gujarat Limited", symbol: "UNITEDPOLY" },
    {
      name: "The United Nilgiri Tea Estates Company Limited",
      symbol: "UNITEDTEA",
    },
    { name: "Univastu India Limited", symbol: "UNIVASTU" },
    { name: "Universal Cables Limited", symbol: "UNIVCABLES" },
    { name: "Universus Photo Imagings Limited", symbol: "UNIVPHOTO" },
    { name: "UNO Minda Limited", symbol: "UNOMINDA" },
    { name: "UPL Limited", symbol: "UPL" },
    { name: "Urja Global Limited", symbol: "URJA" },
    { name: "Usha Martin Limited", symbol: "USHAMART" },
    { name: "UTI Asset Management Company Limited", symbol: "UTIAMC" },
    { name: "Uttam Sugar Mills Limited", symbol: "UTTAMSUGAR" },
    { name: "V2 Retail Limited", symbol: "V2RETAIL" },
    { name: "Vadilal Industries Limited", symbol: "VADILALIND" },
    { name: "Vaibhav Global Limited", symbol: "VAIBHAVGBL" },
    { name: "Vaishali Pharma Limited", symbol: "VAISHALI" },
    { name: "Vakrangee Limited", symbol: "VAKRANGEE" },
    { name: "Valiant Organics Limited", symbol: "VALIANTORG" },
    { name: "Vardhman Acrylics Limited", symbol: "VARDHACRLC" },
    { name: "Vardhman Polytex Limited", symbol: "VARDMNPOLY" },
    { name: "Varroc Engineering Limited", symbol: "VARROC" },
    { name: "Vascon Engineers Limited", symbol: "VASCONEQ" },
    { name: "Vaswani Industries Limited", symbol: "VASWANI" },
    { name: "Varun Beverages Limited", symbol: "VBL" },
    { name: "Vaxtex Cotfab Limited", symbol: "VCL" },
    { name: "Vedanta Limited", symbol: "VEDL" },
    { name: "Venky's (India) Limited", symbol: "VENKEYS" },
    { name: "Venus Pipes & Tubes Limited", symbol: "VENUSPIPES" },
    { name: "Venus Remedies Limited", symbol: "VENUSREM" },
    { name: "Veranda Learning Solutions Limited", symbol: "VERANDA" },
    { name: "Vertoz Advertising Limited", symbol: "VERTOZ" },
    { name: "Vesuvius India Limited", symbol: "VESUVIUS" },
    { name: "Veto Switchgears And Cables Limited", symbol: "VETO" },
    { name: "V-Guard Industries Limited", symbol: "VGUARD" },
    { name: "Vardhman Holdings Limited", symbol: "VHL" },
    { name: "Viceroy Hotels Limited", symbol: "VICEROY" },
    { name: "Vidhi Specialty Food Ingredients Limited", symbol: "VIDHIING" },
    { name: "Vijaya Diagnostic Centre Limited", symbol: "VIJAYA" },
    { name: "Viji Finance Limited", symbol: "VIJIFIN" },
    { name: "Vikas EcoTech Limited", symbol: "VIKASECO" },
    { name: "Vikas Lifecare Limited", symbol: "VIKASLIFE" },
    { name: "Vikas Proppant & Granite Limited", symbol: "VIKASPROP" },
    { name: "Vikas WSP Limited", symbol: "VIKASWSP" },
    { name: "Vimta Labs Limited", symbol: "VIMTALABS" },
    { name: "Vinati Organics Limited", symbol: "VINATIORGA" },
    { name: "Vindhya Telelinks Limited", symbol: "VINDHYATEL" },
    { name: "Vineet Laboratories Limited", symbol: "VINEETLAB" },
    { name: "Vinny Overseas Limited", symbol: "VINNY" },
    { name: "Vinyl Chemicals (India) Limited", symbol: "VINYLINDIA" },
    { name: "VIP Clothing Limited", symbol: "VIPCLOTHNG" },
    { name: "VIP Industries Limited", symbol: "VIPIND" },
    { name: "Vipul Limited", symbol: "VIPULLTD" },
    { name: "Visaka Industries Limited", symbol: "VISAKAIND" },
    { name: "Visa Steel Limited", symbol: "VISASTEEL" },
    { name: "Visesh Infotecnics Limited", symbol: "VISESHINFO" },
    { name: "Vishal Fabrics Limited", symbol: "VISHAL" },
    { name: "Vishnu Chemicals Limited", symbol: "VISHNU" },
    { name: "Vishwaraj Sugar Industries Limited", symbol: "VISHWARAJ" },
    { name: "Visagar Polytex Limited", symbol: "VIVIDHA" },
    { name: "VLS Finance Limited", symbol: "VLSFINANCE" },
    { name: "V-Mart Retail Limited", symbol: "VMART" },
    { name: "Voltamp Transformers Limited", symbol: "VOLTAMP" },
    { name: "Voltas Limited", symbol: "VOLTAS" },
    { name: "VRL Logistics Limited", symbol: "VRLLOG" },
    { name: "Vardhman Special Steels Limited", symbol: "VSSL" },
    { name: "VST Industries Limited", symbol: "VSTIND" },
    { name: "V.S.T Tillers Tractors Limited", symbol: "VSTTILLERS" },
    { name: "Vardhman Textiles Limited", symbol: "VTL" },
    { name: "VA Tech Wabag Limited", symbol: "WABAG" },
    { name: "Walchandnagar Industries Limited", symbol: "WALCHANNAG" },
    { name: "Wanbury Limited", symbol: "WANBURY" },
    { name: "Waterbase Limited", symbol: "WATERBASE" },
    { name: "Wealth First Portfolio Managers Limited", symbol: "WEALTH" },
    { name: "Websol Energy System Limited", symbol: "WEBELSOLAR" },
    { name: "Weizmann Limited", symbol: "WEIZMANIND" },
    { name: "Wonder Electricals Limited", symbol: "WEL" },
    { name: "Welspun Corp Limited", symbol: "WELCORP" },
    { name: "Welspun Enterprises Limited", symbol: "WELENT" },
    { name: "Welspun Investments and Commercials Limited", symbol: "WELINV" },
    { name: "Welspun India Limited", symbol: "WELSPUNIND" },
    { name: "Wendt (India) Limited", symbol: "WENDT" },
    { name: "WESTLIFE FOODWORLD LIMITED", symbol: "WESTLIFE" },
    { name: "WE WIN LIMITED", symbol: "WEWIN" },
    { name: "Wheels India Limited", symbol: "WHEELS" },
    { name: "Whirlpool of India Limited", symbol: "WHIRLPOOL" },
    { name: "Williamson Magor & Company Limited", symbol: "WILLAMAGOR" },
    { name: "Windlas Biotech Limited", symbol: "WINDLAS" },
    { name: "Windsor Machines Limited", symbol: "WINDMACHIN" },
    { name: "WinPro Industries Limited", symbol: "WINPRO" },
    { name: "The Western India Plywoods Limited", symbol: "WIPL" },
    { name: "Wipro Limited", symbol: "WIPRO" },
    { name: "Wockhardt Limited", symbol: "WOCKPHARMA" },
    { name: "Wonderla Holidays Limited", symbol: "WONDERLA" },
    { name: "Worth Peripherals Limited", symbol: "WORTH" },
    { name: "West Coast Paper Mills Limited", symbol: "WSTCSTPAPR" },
    { name: "Xchanging Solutions Limited", symbol: "XCHANGING" },
    { name: "Xelpmoc Design And Tech Limited", symbol: "XELPMOC" },
    { name: "Xpro India Limited", symbol: "XPROINDIA" },
    { name: "Yaari Digital Integrated Services Limited", symbol: "YAARI" },
    { name: "Yes Bank Limited", symbol: "YESBANK" },
    { name: "Yuken India Limited", symbol: "YUKEN" },
    { name: "Zee Entertainment Enterprises Limited", symbol: "ZEEL" },
    { name: "Zee Learn Limited", symbol: "ZEELEARN" },
    { name: "Zee Media Corporation Limited", symbol: "ZEEMEDIA" },
    { name: "Zenith Exports Limited", symbol: "ZENITHEXPO" },
    { name: "Zenith Steel Pipes & Industries Limited", symbol: "ZENITHSTL" },
    { name: "Zensar Technologies Limited", symbol: "ZENSARTECH" },
    { name: "Zen Technologies Limited", symbol: "ZENTEC" },
    {
      name: "ZF Commercial Vehicle Control Systems India Limited",
      symbol: "ZFCVINDIA",
    },
    { name: "Zim Laboratories Limited", symbol: "ZIMLAB" },
    { name: "Zodiac Energy Limited", symbol: "ZODIAC" },
    { name: "Zodiac Clothing Company Limited", symbol: "ZODIACLOTH" },
    { name: "Zomato Limited", symbol: "ZOMATO" },
    { name: "Zota Health Care LImited", symbol: "ZOTA" },
    { name: "Zuari Agro Chemicals Limited", symbol: "ZUARI" },
    { name: "ZUARI INDUSTRIES LIMITED", symbol: "ZUARIIND" },
    { name: "Zydus Lifesciences Limited", symbol: "ZYDUSLIFE" },
    { name: "Zydus Wellness Limited", symbol: "ZYDUSWELL" },
  ]; // Example array of stock names

  const item = JSON.parse(localStorage.getItem('userInfo'));
  console.log(item);
  const id = item._id;

  const getData = async(id)=>{
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const data  = await axios.post(
        "https://neonest-backend.vercel.app/api/portfolio/getportfolio",
        { id },
        config
      );
      // console.log(data.data.port);
      return data;
    }catch(error){
      console.log(error);
    }
  }

  useEffect(() => {
    // const name = item.name;
    const fetchData = async() =>{
    const data = await getData(id);
    console.log(data.data.port);
    setPortfolio(data.data.port);
    }
    fetchData();
  },[portfolio]);

  const handleInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    const results = stockNames
      .filter((stock) => stock.name.toLowerCase().includes(query.toLowerCase()))
      .slice(0, 3);
    setSearchResult(results);
  };

  const handleBuySell = async(stock,action) =>{
    console.log(quantity);
    console.log(`Performing ${action} for ${stock.symbol}`);
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      
      if(action === "buy"){
        const {data}  = await axios.post(
          "https://neonest-backend.vercel.app/api/portfolio/buystock",
          { id,name:selectedStock.name,quantity,bp:price },
          config
        );
        console.log(data);
      }
      else{
        const {data}  = await axios.post(
          "https://neonest-backend.vercel.app/api/portfolio/sellstock",
          { id,name:selectedStock.name,quantity,sp:price },
          config
        );
        console.log(data);
      }
      setSelectedStock(null);
      const data = await getData(id);
      setPortfolio(data.data.port);
    }catch(error){
      console.log(error);
    }
  }

  const handleDetailQuote = async(stockSymbol, action) => {
    const selected = stockNames.find(stock => stock.symbol === stockSymbol.symbol);
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const {data}  = await axios.post(
        "https://neonest-backend.vercel.app/api/portfolio/getprice",
        { name:selected.name },
        config
      );
      console.log(data.data['Global Quote']);
      setPrice(data.data['Global Quote']['05. price']);
      setHighPrice(data.data['Global Quote']['03. high']);
      setLowPrice(data.data['Global Quote']['04. low']);
      setOpen(data.data['Global Quote']['02. open']);
      setVolume(data.data['Global Quote']['06. volume']);
      setSelectedStock(selected);
    }catch(error){
      console.log(error);
    }
  };

  const closeDialog = () => {
    setQuantity(0);
    setSelectedStock(null);
  };

  return (
    <div>
      <StockNavbar />
      <div className="container">
        <div className="left-image"></div>
        <div className="right-section">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search..."
              className="search-input"
              value={searchQuery}
              onChange={handleInputChange} 
            />
            <FaSearch className="search-icon" />
          </div>
          {searchQuery && (
            <div className="search-results">
              <h2>Search Results</h2>
              <div className="search-results-container">
                {searchResult.map((stock, index) => (
                  <div key={index} className="search-result-item">
                    <span>{stock.name}</span>
                    {/* <div className="buy-sell-buttons">
                      <button onClick={() => handleDetailQuote(stock, 'buy')} className="buy-button">DetailQuote</button>
                    </div> */}
                     <div className="predict-button-container">
                     <button onClick={() => handleDetailQuote(stock, 'buy')} className="predict-button">View Details</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          { selectedStock && (
            <div className="dialog">
            <div className="dialog-content">
              <h2>{selectedStock.name}</h2>
              <span>Open : {open}</span><br></br>
              <span>HighPrice : {highprice}</span><br></br>
              <span>LowPrice : {lowprice}</span><br></br>
              <span>Price : {price}</span><br></br>
              <span>Volume : {volume}</span><br></br>
              
              <span className="mb-2 text-sm md:text-md text-white">quantity</span>
          <input
            className="w-full p-2 border border-gray-300 rounded-md placeholder:font-light placeholder:text-gray-500"
            value= {quantity}
            type="number"
            placeholder="Enter quantity to buy/sell"
            onChange={(e) => setQuantity(e.target.value)}
          />
<button onClick={() => handleBuySell(selectedStock, 'buy')} className="buy-button">Buy</button>
<button onClick={() => handleBuySell(selectedStock, 'sell')} className="sell-button">Sell</button>

          <button onClick={closeDialog} className="close-button">Close</button>

            </div>
          </div>
          )}
          {/* Your table code goes here */}
          <table className="stock-table">
            <thead>
            <tr>
                <th>Stock Name</th>
                {/* <th>Price</th> */}
                <th>Cost Price</th>
                <th>Selling Price</th>
                <th>Quantity</th>
                <th>Profit/Loss</th>
                {/* <th>Buy</th>
                <th>Sell</th> */}
              </tr>
            </thead>
            <tbody>
            {portfolio.map((portt, index) => (
            <tr key={index}>
              <td >{portt.stockName}</td>
              <td >{portt.buyPrice}</td>
              <td >{portt.sellPrice}</td>
              <td >{portt.quantity}</td>
              <td>{portt.profitLoss}</td>
              {/* <td>
                  <button className="buy-button">Buy</button>
                </td>
                <td>
                  <button className="sell-button">Sell</button>
                </td> */}
            </tr>
          ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
